<template>
  <v-dialog
    v-model="modalAberto"
    transition="dialog-bottom-transition"
    max-width="1200"
    :z-index="3005"
    content-class="criar-agendamento-dialog-content"
    persistent
  >
    <v-card class="criar-agendamento-modal mx-auto" :loading="carregando ? 'success' : null" :disabled="carregando">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-icon">
            <v-icon size="28" color="white">mdi-bookmark-plus-outline</v-icon>
          </div>
          <div class="header-text">
            <h2 class="header-title">{{ titulo }}</h2>
            <p class="header-subtitle">Crie e gerencie seus agendamentos</p>
          </div>
        </div>
        <v-btn icon dark class="close-btn" @click="fecharModal()">
          <v-icon size="24">mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="unified-content">
        <v-card class="unified-card" flat>
          <validation-observer ref="observer" v-slot="{ }">
            <form @submit.prevent="salvar">
              <v-overlay :value="carregando" opacity="0.9">
                <div class="d-flex flex-column align-center">
                  <v-progress-circular indeterminate size="48" />
                  <div class="mt-4 text-subtitle-1 font-weight-medium">
                    Carregando agenda…
                  </div>
                  <div class="mt-1 text-body-2">
                    Aguarde um instante, estamos buscando os horários reservados.
                  </div>
                </div>
              </v-overlay>
              <v-card-text class="form-content">
                <v-row align="center" no-gutters>
                  <v-col class="d-flex align-center" cols="12" sm="12" md="9">
                    <v-btn-toggle dense v-model="agendamento.tipoAgendamento" group class="mb-n6 mt-n6"
                      @change="onChangeTipoAgendamento" :disabled="isAdicionarPacienteColetivo">
                      <v-btn class="buttons-toggle" small :value="tipoAgendamento.Consulta"
                        :disabled="isAdicionarPacienteColetivo || editarAgendamento || agendamento.tipoAgendamento === tipoAgendamento.Consulta">
                        Consulta
                      </v-btn>
                      <v-btn v-if="!agendamentoRetorno" class="buttons-toggle" small
                        :value="tipoAgendamento.Compromisso"
                        :disabled="isAdicionarPacienteColetivo || editarAgendamento || agendamento.tipoAgendamento === tipoAgendamento.Compromisso">
                        Compromisso
                      </v-btn>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-if="!agendamentoRetorno" class="buttons-toggle" small
                            :value="tipoAgendamento.Coletivo"
                            :disabled="isAdicionarPacienteColetivo || editarAgendamento || agendamento.tipoAgendamento === tipoAgendamento.Coletivo"
                            v-bind="attrs" v-on="on">
                            Agendamento Coletivo
                          </v-btn>
                        </template>
                        <span>Permite agendar múltiplos pacientes no mesmo horário</span>
                      </v-tooltip>
                    </v-btn-toggle>
                  </v-col>
                  <v-col cols="auto" class="d-flex justify-end">
                    <soi-radio v-if="!ocultarRadioTipoPagamento" :items="opcoesFiltro"
                      v-model="tipoPagamentoAtendimento" @input="onInputTipoPagamentoAtendimento">
                    </soi-radio>
                  </v-col>
                </v-row>
                <v-row
                  v-if="agendamento.tipoAgendamento === tipoAgendamento.Consulta && !agendamentoRetorno && !editarAgendamento"
                  class="mt-2">
                  <v-col cols="12" sm="12" md="12">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          <v-checkbox v-model="preAgendamento" label="Pré-agendamento" @change="alterarPreAgendamento"
                            class="mt-0"></v-checkbox>
                        </span>
                      </template>
                      <span>
                        Utilizada para agendamentos de novos pacientes, cujo cadastro será criado após a confirmação do
                        agendamento,
                        apenas com informações básicas.
                      </span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row class="p-10">
                  <v-col v-if="agendamento.tipoAgendamento == tipoAgendamento.Consulta" cols="12" sm="12" md="3">
                    <validation-provider name="Tipo de Consulta" :rules="{ required_select: true }" v-slot="{ errors }">
                      <soi-select v-model="agendamento.tipoConsultaId" label="Tipo de Consulta *"
                        :items="options_consulta" :disabled="agendamentoRetorno" :error-messages="errors" />
                    </validation-provider>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ===
                    tipoAgendamento.Consulta &&
                    preAgendamento
                  " cols="12" sm="12" md="8">
                    <soi-input v-model="agendamento.agendamentoConsulta.paciente.nomeCompleto"
                      :label="'Nome Completo *'" :name="'NomeCompleto'" prepend-icon="mdi-account-plus"
                      :rules="{ required: true }"></soi-input>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ===
                    tipoAgendamento.Consulta &&
                    !preAgendamento
                  " cols="12" sm="12" :md="agendamentoRetorno || editarAgendamento ? 9 : 8">
                    <v-tooltip bottom :disabled="!editarAgendamento">
                      <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on">
                          <validation-provider name="Paciente" :rules="{ required: !editarAgendamento }"
                            v-slot="{ errors, validate }">
                            <soi-picker name="pacientes" :value="pacienteSelecionado"
                              :disabled="agendamentoRetorno || editarAgendamento" prepend-icon="mdi-account-search"
                              label="Paciente *" icon="mdi-account" title="Buscar Paciente" :headers="colunasPaciente"
                              :items="pacientes" :actions="actionsPaciente" :hint="editarAgendamento || agendamentoRetorno
                                ? ''
                                : 'Caso o paciente não possua cadastro, clique no botão ao lado'
                                " :singleSelect="true" @change="changePaciente" @update="getPacientes"
                              @editar="abrirModalEditarPaciente" :error="errors.length > 0"
                              :error-messages="errors"></soi-picker>
                            <input type="hidden" v-model="idPacienteSelecionado" @input="validate" />
                          </validation-provider>
                        </div>
                      </template>
                      <span>Para agendar outro paciente neste horário, é necessário primeiro cancelar o agendamento
                        existente.</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ===
                    tipoAgendamento.Coletivo
                  " cols="12" sm="12" md="11">
                    <validation-provider name="Pacientes" :rules="{ required: true }" v-slot="{ errors }">
                      <soi-picker name="pacientes-coletivo" :value="pacientesColetivosTexto"
                        :disabled="editarAgendamento" prepend-icon="mdi-account-multiple" label="Pacientes *"
                        icon="mdi-account-multiple" title="Buscar Pacientes" :headers="colunasPaciente"
                        :items="pacientesDisponiveisColetivo"
                        hint="Selecione um ou mais pacientes para o agendamento coletivo" :singleSelect="false"
                        @change="changePacientesColetivo" @update="getPacientes" :error="errors.length > 0"
                        :error-messages="errors" :actions="actionsPaciente"
                        @editar="abrirModalEditarPaciente"></soi-picker>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento === tipoAgendamento.Coletivo && !editarAgendamento" cols="12"
                    sm="12" md="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn block color="success" @click="abrirModalCriarPaciente()" v-bind="attrs" v-on="on">
                          <v-icon>mdi-account-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Criar novo paciente</span>
                    </v-tooltip>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Compromisso
                  " cols="12" sm="12" md="12">
                    <soi-input v-model="agendamento.agendamentoCompromisso.descricao
                      " :label="'Descrição do compromisso *'" :name="'Descrição'" :rules="{ required: true }">
                    </soi-input>
                  </v-col>

                  <!-- Tabela de Pacientes Selecionados para Agendamento Coletivo -->
                  <v-col
                    v-if="agendamento.tipoAgendamento === tipoAgendamento.Coletivo && pacientesSelecionadosColetivo.length > 0"
                    cols="12">
                    <v-card outlined class="mt-2">
                      <v-card-title class="subtitle-1 grey lighten-4">
                        <v-icon left color="success">mdi-account-multiple-check</v-icon>
                        <span class="ml-1">Pacientes Selecionados ({{ pacientesSelecionadosColetivo.length }})</span>
                      </v-card-title>
                      <v-card-text class="pa-0">
                        <v-simple-table>
                          <template v-slot:default>
                            <thead>
                              <tr>
                                <th class="text-left">Paciente</th>
                                <th class="text-left" style="width:220px">Telefone</th>
                                <th class="text-left" style="width:200px">Convênio</th>
                                <th class="text-center">Status</th>
                                <th class="text-center">Tipo Consulta</th>
                                <th class="text-center">Retorno</th>
                                <th class="text-center">Confirmado</th>
                                <th class="text-center">Ações</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(pacienteColetivo, index) in pacientesSelecionadosColetivo" :key="index">
                                <td class="align-middle">{{ pacienteColetivo.nomeCompleto ||
                                  pacienteColetivo.nomeExibirSocial }}</td>
                                <td class="align-middle" style="width:220px">{{ pacienteColetivo.telefone || '-' }}</td>
                                <td class="align-middle py-2" style="width:200px">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <div v-bind="attrs" v-on="on">
                                        <soi-select v-model="pacienteColetivo.convenioId" :items="(pacienteColetivo.conveniosDisponiveis && pacienteColetivo.conveniosDisponiveis.length > 0)
                                          ? pacienteColetivo.conveniosDisponiveis
                                          : [{ value: null, text: 'Não registrado', periodoRetornoDias: 0 }]" dense
                                          hide-details @input="mudarPlanosColetivo(pacienteColetivo)"></soi-select>
                                      </div>
                                    </template>
                                    <span>{{ getConvenioFullName(pacienteColetivo) }}</span>
                                  </v-tooltip>
                                </td>
                                <td class="text-center align-middle">
                                  <v-menu bottom right>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn small outlined
                                        :color="corDaSituacaoAgendamento(pacienteColetivo.situacaoAgendamento || 0)"
                                        v-bind="attrs" v-on="on">
                                        <v-icon small
                                          :color="corDaSituacaoAgendamento(pacienteColetivo.situacaoAgendamento || 0)">
                                          {{ iconeDaSituacaoAgendamento(pacienteColetivo.situacaoAgendamento || 0) }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                    <v-list dense>
                                      <v-list-item v-for="item in opcoesSituacaoAgendamento" :key="item.value"
                                        @click="clickSituacaoAgendamentoColetivo(pacienteColetivo, item.value)">
                                        <v-list-item-title>
                                          <v-icon :color="item.color" left x-small>{{ item.icon }}</v-icon>
                                          <span :class="`${item.color}--text`">{{ item.text }}</span>
                                        </v-list-item-title>
                                      </v-list-item>
                                    </v-list>
                                  </v-menu>
                                </td>
                                <td class="text-center align-middle py-2">
                                  <soi-select v-model="pacienteColetivo.tipoConsultaId" :items="options_consulta" dense
                                    hide-details></soi-select>
                                </td>
                                <td class="text-center align-middle py-1">
                                  <v-switch v-model="pacienteColetivo.retorno" dense hide-details
                                    class="mt-0 d-flex justify-center"></v-switch>
                                </td>
                                <td class="text-center align-middle py-1">
                                  <v-switch v-model="pacienteColetivo.agendamentoConfirmado" dense hide-details
                                    class="mt-0 d-flex justify-center"></v-switch>
                                </td>
                                <td class="text-center align-middle">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn icon small color="primary"
                                        @click="abrirModalObservacoes(pacienteColetivo, index)" v-bind="attrs"
                                        v-on="on">
                                        <v-icon small>mdi-eye</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Visualizar/Editar Observações</span>
                                  </v-tooltip>
                                  <v-tooltip bottom v-if="!editarAgendamento">
                                    <template v-slot:activator="{ on, attrs }">
                                      <span v-bind="attrs" v-on="on">
                                        <v-btn icon small color="error"
                                          @click="removerPacienteColetivo(pacienteColetivo)">
                                          <v-icon small>mdi-delete</v-icon>
                                        </v-btn>
                                      </span>
                                    </template>
                                    <span>Excluir agendamento individual</span>
                                  </v-tooltip>
                                </td>
                              </tr>
                            </tbody>
                          </template>
                        </v-simple-table>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento == tipoAgendamento.Consulta &&
                    !agendamentoRetorno &&
                    !editarAgendamento &&
                    !preAgendamento
                  " cols="12" sm="12" md="1">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn block color="success" @click="abrirModalCriarPaciente()" v-bind="attrs" v-on="on">
                          <v-icon>mdi-account-plus</v-icon>
                        </v-btn>
                      </template>
                      <span>Criar novo paciente</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition"
                      offset-y min-width="290px" content-class="date-picker-menu" :nudge-top="10"
                      :disabled="isEdicaoColetivo || isAdicionarPacienteColetivo">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field name="data" color="success" outlined dense v-model="agendamento.dataAgendamento
                          " label="Data *" persistent-hint prepend-icon="mdi-calendar" v-bind="attrs" readonly
                          :disabled="isEdicaoColetivo || isAdicionarPacienteColetivo" v-mask="masks.data" @blur="
                            date = parseDate(
                              agendamento.dataAgendamento
                            )
                            " v-on="on">
                        </v-text-field>
                      </template>
                      <v-date-picker color="success" v-model="date" @change="
                        buscarHorarios(
                          agendamento.agendaId,
                          date
                        )
                        " no-title @input="menu1 = false" locale="pt-BR" :allowed-dates="desabilitarDatas"
                        :disabled="isEdicaoColetivo || isAdicionarPacienteColetivo"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider v-slot="{ errors }" name="Horário" :rules="{ required: true }">
                      <v-select name="Horário" @input="preencherDuracaoAgendamento()"
                        v-model="agendamento.horaAgendamento" :error-messages="errors" label="Horário *"
                        no-data-text="Configure os horários" :items="horarios" :nullable="false" outlined dense
                        color="success" item-color="success"
                        :disabled="isEdicaoColetivo || isAdicionarPacienteColetivo">
                      </v-select>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="3" sm="12">
                    <validation-provider v-slot="{ errors }" name="Duração" :rules="{ required: true }">
                      <v-text-field label="Duração *" name="Duração" v-model="agendamento.duracaoAgendamento"
                        type="time" dense outlined color="success" :error-messages="errors"
                        :disabled="isEdicaoColetivo || isAdicionarPacienteColetivo">
                        <template v-slot:append-outer>
                          <v-tooltip bottom v-if="isEdicaoColetivo || isAdicionarPacienteColetivo">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon small color="info" v-bind="attrs" v-on="on">mdi-information</v-icon>
                            </template>
                            <span>
                              Para alterar os dados destes campos, cancele o agendamento e crie um novo com os dados
                              desejados.
                            </span>
                          </v-tooltip>
                        </template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="!agendamentoRetorno && agendamento.tipoAgendamento !== tipoAgendamento.Coletivo"
                    cols="12" md="3" sm="12">
                    <v-menu bottom right>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn height="40" block outlined color="grey darken-2" v-bind="attrs" v-on="on">
                          <v-icon left dense :color="corDaSituacaoAgendamento(
                            agendamento.situacaoAgendamento
                          )
                            ">
                            {{
                              iconeDaSituacaoAgendamento(
                                agendamento.situacaoAgendamento
                              )
                            }}
                          </v-icon>
                          <span :class="`${corDaSituacaoAgendamento(
                            agendamento.situacaoAgendamento
                          )}`"></span>
                          <v-icon right>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-for="item in opcoesSituacaoAgendamento" :key="item.value"
                          @click="clickSituacaoAgendamento(item.value)">
                          <v-list-item-title :text-color="item.color">
                            <v-icon :color="item.color" left dense>{{ item.icon }}</v-icon>
                            <span :class="`${item.color}--text`">{{ ' ' + item.text }}</span>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Consulta &&
                    !agendamentoRetorno &&
                    !preAgendamento
                  " cols="12" md="4" sm="12">
                    <soi-input :label="'CPF'" :name="'CPF'" v-model="cpfPaciente" :disabled="true"
                      :placeholder="'000.000.000-00'" :mask="masks.cpf" :rules="{
                        min: 14,
                        cpf: 'cpf',
                        required: false,
                      }">
                    </soi-input>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Consulta &&
                    !agendamentoRetorno &&
                    !preAgendamento
                  " cols="12" md="5" sm="12">
                    <soi-input :label="'Email'" :name="'Email'" v-model="agendamento.agendamentoConsulta.email
                      "></soi-input>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Consulta
                  " cols="12" :md="preAgendamento ? 4 : 3" sm="12">
                    <soi-input :label="'Telefone'" :name="'Telefone'" v-model="agendamento.agendamentoConsulta.telefone
                      " :mask="masks.telefone"></soi-input>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Consulta
                  " cols="12" :md="agendamento.tipoAgendamento === tipoAgendamento.Consulta && !preAgendamento ? 6 : 4"
                    sm="12">
                    <validation-provider v-slot="{ errors }" name="Convenio" :rules="regrasConvenio"
                      ref="providerConvenio">
                      <soi-select v-model="agendamento.agendamentoConsulta
                        .convenioId" label="Convênio" :items="options_convenio" @input="mudarPlanos"
                        :disabled="desabilitarConvenio || verificaSeRadioParticularEstaSelecionado" name="Convenio"
                        :error-messages="errors">
                      </soi-select>
                    </validation-provider>
                  </v-col>
                  <v-col v-if="agendamento.tipoAgendamento ==
                    tipoAgendamento.Consulta
                  " cols="12" :md="agendamento.tipoAgendamento === tipoAgendamento.Consulta && !preAgendamento ? 6 : 5"
                    sm="12">
                    <soi-select v-model="agendamento.agendamentoConsulta.planoId
                      " label="Plano" :items="options_plano"
                      :disabled="!preAgendamento && !pacienteSelecionado && desabilitarConvenio || verificaSeRadioParticularEstaSelecionado">
                    </soi-select>
                  </v-col>
                </v-row>
                <v-row class="align-center mb-6 no-gutters">
                  <v-col v-if="agendamento.tipoAgendamento == tipoAgendamento.Consulta && idPacienteSelecionado"
                    cols="12" md="6" sm="12" class="d-flex">
                    <v-chip outlined color="grey darken-1" class="ml-2" label small>
                      <v-icon left small>mdi-clock-outline</v-icon>
                      Última consulta:
                      {{ ultimaConsultaPaciente }}
                    </v-chip>
              </v-col>
              <v-col v-if="agendamento.tipoAgendamento == tipoAgendamento.Consulta" cols="12" md="2" sm="12">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <soi-switch class="mt-n1" v-model="agendamento.agendamentoConsulta.retorno" :label="'Retorno'"
                        :disabled="agendamentoRetorno">
                      </soi-switch>
                    </span>
                  </template>
                  <span v-if="mostrarTooltipRetorno">{{ mensagemTooltipRetorno }}</span>
                </v-tooltip>
              </v-col>
              <v-col v-if="agendamento.tipoAgendamento ==
                tipoAgendamento.Consulta
              " cols="12" md="4" sm="12">
                <soi-switch class="mt-n1" v-model="agendamento.agendamentoConfirmado"
                  :label="'Agendamento confirmado'"></soi-switch>
              </v-col>
            </v-row>
            <v-row class="p-10">
              <v-col cols="12" sm="12" md="12">
                <v-textarea class="ml-1" label="Observação" outlined rows="1" color="success"
                  v-model="agendamento.observacaoAgendamento">
                </v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  class="ml-1" label="Orientações ao Paciente" outlined rows="1" color="success"
                  v-model="agendamento.orientacoesPaciente">
                </v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="form-actions">
            <v-spacer></v-spacer>
            <v-row justify="end" class="actions-container">
              <v-btn
                v-if="exibirTriagemRetorno"
                id="triagem"
                color="primary"
                :loading="carregando"
                class="mr-2 action-btn triagem-btn"
                :disabled="desabilitarBotaoTriagem
              || agendamento.tipoAgendamento === tipoAgendamento.Compromisso || desabilitaModulosComplementares()"
                v-show="!desabilitaModulosComplementares()"
                @click="realizarTriagemParaForm()"
              >
                <v-icon left>mdi-checkbox-marked-circle</v-icon>
                Realizar Triagem
              </v-btn>
              <v-btn dense color="warning" @click="fecharModal()" class="mr-2 action-btn cancel-btn" :loading="carregando">
                <v-icon left>mdi-keyboard-return</v-icon> Voltar
              </v-btn>
              <v-btn id="salvar" type="input" color="success" class="action-btn save-btn" :loading="carregando" :disabled="carregando">
                <v-icon left>$saveIcon</v-icon> Salvar
              </v-btn>
            </v-row>
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>
    </div>
    </v-card>
    <ModalConfirmaCancelamentoAgendamento v-model="confirmaCancelamentoAgendamento" @confirm="onConfirmarCancelamento"
      @cancel="fecharDialog" />
    <ModalTriagem v-model="modalTriagens" :idAgendamento="idAgendamento" :idPaciente="idPaciente" :isMobile="isMobile"
      @triagemSalva="fecharModalTriagem" @atualizaCalendario="$emit('atualizaCalendario')" />
    <ModalAgendamentosPaciente v-model="modalAgendamentosPaciente" :nomePaciente="nomePacienteModalAgendamentos"
      :pacienteId="pacienteIdModalAgendamentos" :fotoKey="paciente?.foto || ''"
      @confirmar="onConfirmarAgendamentosPaciente" @cancelar="onCancelarAgendamentosPaciente" />
    <!-- Modal de Observações para Agendamento Coletivo -->
    <v-dialog v-model="modalObservacoes" max-width="600" persistent>
      <v-card>
        <v-card-title class="grey lighten-4">
          <v-icon left color="primary">mdi-text-box-outline</v-icon>
          Observações do Agendamento
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharModalObservacoes">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12">
              <p class="subtitle-2 mb-2">
                <strong>Paciente:</strong> {{ pacienteObservacaoAtual?.nomeCompleto ||
                  pacienteObservacaoAtual?.nomeExibirSocial }}
              </p>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="pacienteObservacaoAtual.observacao" label="Observação do Agendamento" outlined
                rows="3" color="success" hint="Informações adicionais sobre este agendamento"></v-textarea>
            </v-col>
            <v-col cols="12">
              <v-textarea v-model="pacienteObservacaoAtual.orientacoesPaciente" label="Orientações ao Paciente" outlined
                rows="3" color="success" hint="Orientações e instruções para o paciente"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" @click="fecharModalObservacoes">
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn color="success" @click="salvarObservacoes">
            <v-icon left>mdi-check</v-icon>
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ModalEditarPaciente ref="modalEditarPaciente" @pacienteEditado="onPacienteEditado" />
    <ModalCriarPaciente ref="modalCriarPaciente" @pacienteCriado="onPacienteCriado" />
  </v-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  AlertaSimplesErro,
  MensagemMixin,
  AlertaPerguntaSimOuNaoBooleano,
  AlertaPerguntaSimOuNaoBooleanoHtml,
  AlertaSimples,
} from '../../helpers/MensagemHelper';
import { CadastroCompletoHelper } from '../../helpers/CadastroCompletoHelper';
import Agendamento from '../../models/agendamento/Agendamento';
import { AgendamentoService } from '../../services/AgendamentoService';
import { TipoConsultaService } from '../../services/TipoConsultaService';
import { ConvenioService } from '../../services/ConveioService';
import { PlanoService } from '../../services/PlanoService';
import { PacientesService } from '../../services/PacientesService';
import MaskHelper from '../../helpers/MaskHelper';
import DateHelper from '../../helpers/DateHelper';
import { TipoAgendamento } from '../../models/enums/EnumTipoAgendamento';
import { SituacaoAgendamento } from '../../models/enums/EnumSituacaoAgendamento';
import AgendamentoConsulta from '../../models/agendamento/AgendamentoConsulta';
import AgendamentoCompromisso from '../../models/agendamento/AgendamentoCompromisso';
import { BloqueioHorarioAgendaService } from '../../services/BloqueioHorarioAgendaService';
import { FeriadoAgendaService } from '../../services/FeriadoAgendaService';
import BloqueioHorarioAgenda from '../../models/agenda/BloqueioHorarioAgenda';
import FeriadoAgenda from '../../models/agenda/FeriadoAgenda';
import Agenda from '../../models/agenda/Agenda';
import Triagem from '../../models/triagem/Triagem';
import Pacientes from '../../models/pacientes/Pacientes';
import { decode, getToken } from '@/utils/Token';
import PermissoesPadrao from '@/constants/enums/PermissoesPadrao';
import { TriagemService } from '@/services/TriagemService';
import { AgendaService } from '@/services/AgendaService';
import { IHorarioReservado } from '@/models/agenda/IHorarioReservado';
import { TenantService } from '@/services/TenantService';
import ModalAgendamentosPaciente from '@/components/ModalAgendamentosPaciente.vue';
import { AtendimentoService } from '@/services/AtendimentoService';
import ModalConfirmaCancelamentoAgendamento from './ModalConfirmaCancelamentoAgendamento.vue';
import ModalTriagem from './ModalTriagem.vue';
import { TipoPagamentoAtendimento } from '@/models/enums/EnumTipoPagamentoAtendimento';
import ModalEditarPaciente from '../paciente/ModalEditarPaciente.vue';
import ModalCriarPaciente from '../paciente/ModalCriarPaciente.vue';

export default Vue.component('soi-modalAgendamento', {
  name: 'soi-modalAgendamento',
  components: {
    ModalAgendamentosPaciente,
    ModalConfirmaCancelamentoAgendamento,
    ModalTriagem,
    ModalEditarPaciente,
    ModalCriarPaciente,
  },
  data() {
    return {
      date: DateHelper.formataParaAnoMesDia(
        new Date(Date.now()).toISOString().substr(0, 10),
      ),
      dateFormatted: DateHelper.formataParaDiaMesAno(
        new Date(Date.now()).toISOString().substr(0, 10),
      ),
      ultimaConsultaPaciente: '',
      menu1: false,
      menu2: false,
      modalAberto: false,
      modalTriagens: false,
      desabilitarConvenio: false,
      confirmaCancelamentoAgendamento: false,
      pendingCancelamentoResolve: null as ((value: string) => void) | null,
      validacaoInicialExecutada: false,
      situacaoAgendamentoAnterior: 0,

      // triagem aqui
      triagem: new Triagem(),
      paciente: new Pacientes(),
      dataNascimentoValido: false,
      desabilitarBotaoTriagem: false,

      idAgenda: 1,
      agenda: new Agenda(),
      agendamento: {
        agendaId: 0,
        tipoAgendamento: null,
        dataAgendamento: '',
        horaAgendamento: '',
        agendamentoConfirmado: false,
        duracaoAgendamento: '',
        observacaoAgendamento: '',
        orientacoesPaciente: '',
        situacaoAgendamento: 0,
        agendamentoConsulta: {
          tipoConsultaId: 0,
          email: '',
          telefone: '',
          retorno: false,
          pacienteId: '',
          paciente: {
            nomeCompleto: '',
            dataNascimento: '',
            contato: {
              emailPrincipal: '',
              telefonePrincipal: '',
            },
          },
          convenioId: null,
          planoId: null,
        },
        agendamentoCompromisso: {
          descricao: '',
        },
        tipoConsultaId: 0,
      },
      editarAgendamento: false,

      // Pré-Agendamento
      corFundo: 'success',
      corBotao: 'success',
      preAgendamento: false,

      // AgendamentoRetorno
      agendamentoRetorno: false,
      editarAgendamentoRetorno: '',
      mostrarTooltipRetorno: true,

      // services
      agendamentoService: new AgendamentoService(),
      tipoConsultaService: new TipoConsultaService(),
      convenioService: new ConvenioService(),
      planoService: new PlanoService(),
      pacienteService: new PacientesService(),
      bloqueiosHorariosService: new BloqueioHorarioAgendaService(),
      feriadosService: new FeriadoAgendaService(),
      triagemService: new TriagemService(),
      agendaService: new AgendaService(),
      atendimentoService: new AtendimentoService(),
      ocultarRadioTipoPagamento: false,

      tipoAgendamento: TipoAgendamento,
      carregando: false,
      masks: MaskHelper,
      opcoesSituacaoAgendamento: [
        {
          value: 0,
          text: 'Marcado',
          icon: 'mdi-calendar-check',
          color: '#84b6f4',
        },
        {
          value: 1,
          text: 'Em espera',
          icon: 'mdi-clock-alert-outline',
          color: '#77dd77',
        },
        {
          value: 2,
          text: 'Em andamento',
          icon: 'mdi-progress-check',
          color: '#ffda9e',
        },
        {
          value: 3,
          text: 'Faltou',
          icon: 'mdi-close-octagon-outline',
          color: '#ff6961',
        },
        {
          value: 4,
          text: 'Finalizado',
          icon: 'mdi-check-circle-outline',
          color: '#c5c6c8',
        },
        {
          value: 5,
          text: 'Cancelado',
          icon: 'mdi-cancel',
          color: '#ffe180',
        },
      ],
      opcoesFiltro: [
        { name: 'Particular', key: TipoPagamentoAtendimento.Particular, type: 'number' },
        { name: 'Convênio', key: TipoPagamentoAtendimento.Convenio, type: 'number' },
      ],
      options_convenio: [],
      options_plano: [],
      options_consulta: [],
      horarios: [] as { text: string; value: string }[],
      horariosAgenda: [],
      datasBloqueadas: [] as BloqueioHorarioAgenda[],
      feriados: [] as FeriadoAgenda[],
      minDate: new Date(Date.now()),
      tempListaHorarios: [],
      idPaciente: 0,
      idAgendamento: 0,
      cpfPaciente: '',
      colunasPaciente: [
        {
          text: 'Id',
          align: 'end',
          value: 'id',
          filterable: true,
          sortable: true,
        },
        {
          text: 'CPF',
          align: 'center',
          value: 'cpf',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Nome Completo',
          align: 'start',
          value: 'nomeCompleto',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Nome Social',
          align: 'center',
          value: 'nomeExibirSocial',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Data de Nascimento',
          align: 'start',
          value: 'dataNascimento',
          filterable: true,
        },
        {
          text: 'Idade',
          align: 'center',
          value: 'idade',
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      actionsPaciente: [
        {
          icon: 'mdi-pencil',
          color: 'primary',
          action: 'editar',
          label: 'Editar Paciente',
        },
      ],
      pacientes: [],
      pacienteSelecionado: '',
      idPacienteSelecionado: 0,
      pacientesSelecionadosColetivo: [] as any[],
      pacientesExcluidosColetivo: [] as string[],
      pacientesExcluidosColetivoBanco: [] as string[],
      isAdicionarPacienteColetivo: false,
      modalObservacoes: false,
      pacienteObservacaoAtual: {} as any,
      indexPacienteObservacao: -1,
      SESSAO_PACIENTE_ARMAZENAMENTO: 'agendamento_paciente_session_storage',
      tenantService: new TenantService(),
      tenant: null,
      modalAgendamentosPaciente: false,
      agendamentosPaciente: [],
      aguardandoConfirmacaoAgendamentos: false,
      filaPacientesAgendamentosEncontrados: [] as Array<{
        pacienteId: number;
        nomePaciente: string;
        agendamentos: any[];
        origem: 'consulta' | 'coletivo';
      }>,
      pacienteAgendamentoEncontradoAtual: null as {
        pacienteId: number;
        nomePaciente: string;
        agendamentos: any[];
        origem: 'consulta' | 'coletivo';
      } | null,
      pacienteIdModalAgendamentos: 0,
      nomePacienteModalAgendamentos: '',
      tipoAgendamentoAnterior: null as TipoAgendamento | null,
      ignorarConfirmacaoTrocaTipo: false,
      tipoPagamentoAtendimento: TipoPagamentoAtendimento.Particular,
    };
  },
  watch: {
    modalAberto(valor: boolean) {
      this.atualizarClasseModalAgendamentoAberto(valor);
    },
    date() {
      this.agendamento.dataAgendamento = DateHelper.formataParaDiaMesAno(this.date);
      this.atualizarPacientesColetivoBanco();
    },
    'agendamento.horaAgendamento': function () {
      this.atualizarPacientesColetivoBanco();
    },
    'agendamento.agendamentoConsulta.convenioId': function (novoConvenioId) {
      if (novoConvenioId) {
        const convenioSelecionado = this.options_convenio.find((c) => c.value === novoConvenioId);
        if (convenioSelecionado) {
          this.agendamento.agendamentoConsulta.periodoRetornoDias = convenioSelecionado.periodoRetornoDias;
          this.mostrarTooltipRetorno = true;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      } else {
        this.agendamento.agendamentoConsulta.periodoRetornoDias = 0;
        this.mostrarTooltipRetorno = true;
        this.$nextTick(() => {
          this.$forceUpdate();
        });
      }
    },
    'agendamento.tipoAgendamento': function () {
      this.atualizarPacientesColetivoBanco();
      if (this.agendamento.tipoAgendamento === TipoAgendamento.Consulta) {
        this.opcoesSituacaoAgendamento = [
          {
            value: 0,
            text: 'Marcado',
            icon: 'mdi-calendar-check',
            color: '#84b6f4',
          },
          {
            value: 1,
            text: 'Em espera',
            icon: 'mdi-clock-alert-outline',
            color: '#77dd77',
          },
          {
            value: 2,
            text: 'Em andamento',
            icon: 'mdi-progress-check',
            color: '#FFA500',
          },
          {
            value: 3,
            text: 'Faltou',
            icon: 'mdi-close-octagon-outline',
            color: '#ff6961',
          },
          {
            value: 4,
            text: 'Finalizado',
            icon: 'mdi-check-circle-outline',
            color: '#c5c6c8',
          },
          {
            value: 5,
            text: 'Cancelado',
            icon: 'mdi-cancel',
            color: '#FFD700',
          },
        ];
      } else {
        this.opcoesSituacaoAgendamento = [
          {
            value: 0,
            text: 'Marcado',
            icon: 'mdi-calendar-check',
            color: '#84b6f4',
          },
          {
            value: 1,
            text: 'Em espera',
            icon: 'mdi-clock-alert-outline',
            color: '#77dd77',
          },
          {
            value: 2,
            text: 'Em andamento',
            icon: 'mdi-progress-check',
            color: '#FFA500',
          },
          {
            value: 3,
            text: 'Faltou',
            icon: 'mdi-close-octagon-outline',
            color: '#ff6961',
          },
          {
            value: 4,
            text: 'Finalizado',
            icon: 'mdi-check-circle-outline',
            color: '#c5c6c8',
          },
          {
            value: 5,
            text: 'Cancelado',
            icon: 'mdi-cancel',
            color: '#ffe180',
          },
        ];

        if (!this.opcoesSituacaoAgendamento.find((x) => x.value === this.agendamento.situacaoAgendamento)) {
          this.agendamento.situacaoAgendamento = SituacaoAgendamento.Marcado;
        }
      }
    },
    tipoPagamentoAtendimento(novoValor: number) {
      if (novoValor === TipoPagamentoAtendimento.Convenio) {
        if (this.desabilitarConvenio && !this.preAgendamento) {
          MensagemMixin(3000, 'warning', 'Paciente não possui convênio cadastrado.');

          this.$nextTick(() => {
            this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
          });
          return;
        }
      }
      if (novoValor === TipoPagamentoAtendimento.Particular) {
        this.agendamento.agendamentoConsulta.convenioId = null;
        this.agendamento.agendamentoConsulta.planoId = null;
      }
    },
    regrasConvenio(novaRegra: string) {
      if (novaRegra === 'required') {
        this.$nextTick(() => {
          (this.$refs.providerConvenio as any)?.validate();
        });
      }
    },
    options_convenio(novo) {
      if ((novo.length > 0 && novo[0].value !== null) && this.regrasConvenio === 'required') {
        this.$nextTick(() => {
          (this.$refs.providerConvenio as any)?.validate();
        });
      }
    },
    modalAgendamentosPaciente(val: boolean) {
      if (!val) {
        this.aguardandoConfirmacaoAgendamentos = false;
        if (this.filaPacientesAgendamentosEncontrados.length > 0) {
          this.processarFilaAgendamentosEncontrados();
        }
      }
    },
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    exibirTriagemRetorno: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    isEdicaoColetivo(): boolean {
      return this.editarAgendamento && this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo;
    },

    pacientesDisponiveisColetivo() {
      const idsSelecionados = new Set(
        (this.pacientesSelecionadosColetivo || []).map((p) => `${p.pacienteId || p.id}`),
      );

      if ((this.pacientesExcluidosColetivo && this.pacientesExcluidosColetivo.length > 0)
        || (this.pacientesExcluidosColetivoBanco && this.pacientesExcluidosColetivoBanco.length > 0)) {
        const idsExcluidos = new Set([
          ...(this.pacientesExcluidosColetivo || []),
          ...(this.pacientesExcluidosColetivoBanco || []),
        ].map((id) => `${id}`));
        return (this.pacientes || []).filter((p) => {
          const pacienteId = `${p.id || p.pacienteId}`;
          return !idsExcluidos.has(pacienteId) && !idsSelecionados.has(pacienteId);
        });
      }

      return (this.pacientes || []).filter((p) => {
        const pacienteId = `${p.id || p.pacienteId}`;
        return !idsSelecionados.has(pacienteId);
      });
    },

    mensagemTooltipRetorno(): string {
      if (!this.agendamento.agendamentoConsulta.retorno) {
        return 'Não ativo';
      }
      const convenioSelecionado = this.options_convenio.find(
        (c) => c.value === this.agendamento.agendamentoConsulta.convenioId,
      );

      if (!convenioSelecionado) {
        return 'Não tem convenio selecionado ou não tem paciente selecionado ';
      }

      if (!convenioSelecionado.periodoRetornoDias) {
        return 'Este convênio não possui um período de retorno definido';
      }

      const dataAtual = new Date();
      dataAtual.setDate(dataAtual.getDate() + convenioSelecionado.periodoRetornoDias);
      const dataFormatada = dataAtual.toLocaleDateString('pt-BR');

      return `Atenção: O convênio deste paciente possui um período de retorno de
          ${convenioSelecionado.periodoRetornoDias} dias. Com isso, o retorno poderia ser
          agendado a partir de ${dataFormatada}, caso queira seguir essa recomendação.`;
    },
    regrasConvenio() {
      const ehPagamentoPorConvenio = this.tipoPagamentoAtendimento === TipoPagamentoAtendimento.Convenio;

      if (ehPagamentoPorConvenio && (this.options_convenio.length > 0 && this.options_convenio[0].value !== null && this.idPacienteSelecionado)) {
        return 'required';
      }

      return '';
    },
    cpfValido() {
      return this.$rules.cpf.validate(this.cpfPaciente);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    titulo() {
      if (this.editarAgendamento) {
        return 'Editar Agendamento';
      }
      if (this.agendamentoRetorno) {
        return 'Criar Agendamento Retorno';
      }

      return 'Criar Agendamento';
    },
    verificaEdicao() {
      return this.editarAgendamento;
    },
    verificaSeSituacaoAgendamentoEstaCancelado() {
      return this.agendamento.situacaoAgendamento === SituacaoAgendamento.Cancelado;
    },
    pacientesColetivosTexto() {
      if (!this.pacientesSelecionadosColetivo || this.pacientesSelecionadosColetivo.length === 0) {
        return '';
      }
      return this.pacientesSelecionadosColetivo
        .map((p) => p.nomeCompleto || p.nomeExibirSocial)
        .join(', ');
    },
    verificaSeRadioParticularEstaSelecionado() {
      return this.tipoPagamentoAtendimento === TipoPagamentoAtendimento.Particular;
    },

  },
  async created() {
    await this.getPacientes();
  },
  beforeDestroy() {
    this.atualizarClasseModalAgendamentoAberto(false);
  },
  methods: {
    atualizarClasseModalAgendamentoAberto(modalAberto: boolean) {
      const classe = 'modal-agendamento-open';
      if (modalAberto) {
        document.body.classList.add(classe);
      } else {
        document.body.classList.remove(classe);
      }
    },
    // #region <Funções de abertura e fechamento do Modal de Agendamento>
    async abrirModal(agenda: Agenda, data?: string, idPacienteRetorno?: number, horario?: string) {
      try {
        this.editarAgendamento = false;
        this.agendamentoRetorno = false;
        this.pacientesSelecionadosColetivo = [];
        this.isAdicionarPacienteColetivo = false;
        this.modalObservacoes = false;
        this.pacienteObservacaoAtual = {} as any;
        this.indexPacienteObservacao = -1;
        this.agenda = agenda;
        this.idAgenda = agenda.id;
        const horariosReservadosTodasAsAgendas: IHorarioReservado[] = await this.verificarSeExisteConflitoDeAgenda(data, horario);
        const horariosReservadosAgendaAtual: IHorarioReservado[] = horariosReservadosTodasAsAgendas.filter((item: IHorarioReservado) => item.agendaId === this.idAgenda);

        if (horariosReservadosAgendaAtual) {
          const feriados: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'FERIADO');

          if (feriados && feriados.length > 0) {
            MensagemMixin(8000, 'error', `Este dia está registrado como feriado pela agenda '${feriados[0].nomeAgenda}' e não permite agendamentos!`);
            this.fecharModal();
            return;
          }

          const bloqueios: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'BLOQUEIO');

          if (bloqueios && bloqueios.length > 0) {
            MensagemMixin(8000, 'error', `Este dia foi bloqueado pela agenda '${bloqueios[0].nomeAgenda}' e não permite agendamentos!`);
            this.fecharModal();
            return;
          }

          const bloqueiosHorario: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'BLOQUEIO_HORARIO');

          if (bloqueiosHorario && bloqueiosHorario.length > 0) {
            MensagemMixin(8000, 'error', 'Este horário não está disponível para agendamentos. Há um bloqueio de horário configurado. Escolha outro horário ou remova o bloqueio primeiro.');
            this.fecharModal();
            return;
          }

          const agendamento: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'AGENDAMENTO' && item.situacaoAgendamento !== 5);

          if (agendamento && agendamento.length > 0) {
            MensagemMixin(8000, 'info', `O horário selecionado possui reservas pela agenda: '${agendamento[0].nomeAgenda}'.`);
          }
        }

        const dataEstaBloqueada = data && (await this.dataEstaBloqueada(data));

        if (dataEstaBloqueada) {
          return;
        }

        if (!data) {
          data = await this.buscarProximaDataDisponivel(this.idAgenda);

          if (data === undefined) {
            return;
          }
        }

        this.agendamento = new Agendamento();
        this.tipoAgendamentoAnterior = null;

        if (idPacienteRetorno) {
          this.agendamentoRetorno = true;
          this.agendamento.agendamentoConsulta.retorno = true;
          this.agendamento.agendamentoConsulta.pacienteId = idPacienteRetorno;
          this.mostrarTooltipRetorno = true;

          this.pacienteService.BuscarPacientePorIdComConvenios(idPacienteRetorno)
            .then((res) => {
              const paciente = res.data;

              this.pacienteSelecionado = paciente.usarNomeSocialComoPrincipal
                ? paciente.nomeSocial
                : paciente.nomeCompleto;

              this.cpfPaciente = paciente.cpf;

              this.agendamento.agendamentoConsulta.telefone = paciente.contatos?.telefonePrincipal;

              if (paciente.convenios && paciente.convenios.length > 0) {
                this.options_convenio = paciente.convenios.map((c) => ({
                  value: c.convenioId,
                  text: c.nome,
                  periodoRetornoDias: c.periodoRetornoDias ?? 0,
                }));
              } else {
                this.options_convenio = [{ value: null, text: 'Não registrado', periodoRetornoDias: 0 }];
                this.options_plano = [{ value: null, text: 'Não registrado' }];
                this.agendamento.agendamentoConsulta.convenioId = null;
                this.agendamento.agendamentoConsulta.planoId = null;
              }
              this.desabilitarConvenio = !(paciente.convenios && paciente.convenios.length > 0);
            })
            .catch((erro) => {
              AlertaSimplesErro('Erro ao buscar paciente:', erro);
            });
        }

        this.modalAberto = true;
        this.carregando = true;
        this.desabilitarBotaoTriagem = false;

        await Promise.all([
          this.carregarTipoConsultas(),
          this.preencherConvenios(),
          this.buscarHorarios(this.idAgenda, DateHelper.formatarParaAnosMesDiaISO(data)),
        ]);

        if (idPacienteRetorno) {
          const tipoConsultaRetorno = this.options_consulta.find((consulta) => consulta.text.toLowerCase() === 'retorno');
          if (tipoConsultaRetorno) {
            this.agendamento.tipoConsultaId = tipoConsultaRetorno.value;
          } else {
            AlertaSimplesErro('Aviso:', 'O tipo de consulta "Retorno" não está disponível. Por favor, contate o administrador.');
            this.fecharModal();
            return;
          }
        }

        this.agendamento.horaAgendamento = horario;
        this.agendamento.situacaoAgendamento = SituacaoAgendamento.Marcado;
        this.agendamento.agendaId = this.idAgenda;
        this.agendamento.dataAgendamento = DateHelper.formataParaDiaMesAno(data);
        this.date = DateHelper.formataParaAnoMesDia(data);
        this.preencherDuracaoAgendamento();
        this.carregando = false;

        this.$nextTick(() => {
          this.executarValidacaoInicial();
        });
      } catch (error) {
        AlertaSimplesErro('Aviso:', error);
        this.fecharModal();
      }
    },
    async abrirModalParaAdicionarColetivo(agenda: Agenda, data?: string, horario?: string, pacientesIds?: number[]) {
      let dataNormalizada = data || '';
      if (dataNormalizada) {
        if (dataNormalizada.includes('T')) {
          [dataNormalizada] = dataNormalizada.split('T');
        } else if (dataNormalizada.includes(' ')) {
          [dataNormalizada] = dataNormalizada.split(' ');
        } else if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataNormalizada)) {
          dataNormalizada = DateHelper.formataParaAnoMesDia(dataNormalizada);
        }
      }

      await this.abrirModal(agenda, dataNormalizada || undefined, undefined, horario);
      this.isAdicionarPacienteColetivo = true;
      this.pacientesExcluidosColetivo = Array.isArray(pacientesIds)
        ? pacientesIds.map((id) => `${id}`).filter((id) => id && id !== '0' && id !== 'null' && id !== 'undefined')
        : [];
      this.agendamento.tipoAgendamento = TipoAgendamento.Coletivo;
      this.mudarTipoAgendamento();
      this.pacientesSelecionadosColetivo = [];
    },
    async abrirModalParaEdicao(idAgendamento: number, agenda: Agenda, agendamentoRetorno?: Agendamento) {
      try {
        this.isAdicionarPacienteColetivo = false;
        this.agenda = agenda;
        this.idAgenda = agenda.id;
        await Promise.all([
          this.carregarTipoConsultas(),
          this.preencherConvenios(),
        ]);
        this.editarAgendamento = true;
        this.agendamento = new Agendamento();
        this.carregando = true;
        this.modalAberto = true;
        this.desabilitarConvenio = false;

        let data;
        let agendamento;
        let agendamentoConsulta;
        let dataAgendamento;

        if (!agendamentoRetorno) {
          await this.agendamentoService
            .Get(idAgendamento)
            .then((res) => {
              data = res.data;
            });
          agendamento = data;
          agendamentoConsulta = agendamento.agendamentoConsulta;

          if (agendamentoConsulta) {
            this.pacienteSelecionado = (agendamentoConsulta.paciente.usarNomeSocialComoPrincipal) ? agendamentoConsulta.paciente.nomeSocial : agendamentoConsulta.paciente.nomeCompleto;
            this.idPacienteSelecionado = agendamentoConsulta.pacienteId || agendamentoConsulta.paciente.id;
            this.pacienteService.BuscarPacientePorIdComConvenios(this.idPacienteSelecionado)
              .then((res) => {
                const paciente = res.data;
                if (paciente && paciente.convenios && paciente.convenios.length > 0) {
                  this.options_convenio = paciente.convenios.map((c) => ({
                    value: c.convenioId,
                    text: c.nome,
                    periodoRetornoDias: c.periodoRetornoDias ?? 0,
                  }));
                  this.desabilitarConvenio = false;
                } else {
                  this.options_convenio = [{ value: null, text: 'Não registrado', periodoRetornoDias: 0 }];
                  this.options_plano = [{ value: null, text: 'Não registrado' }];
                  this.agendamento.agendamentoConsulta.convenioId = null;
                  this.agendamento.agendamentoConsulta.planoId = null;
                  this.desabilitarConvenio = true;
                }
              })
              .catch(() => {
                this.desabilitarConvenio = true;
              });
          }
          dataAgendamento = agendamento.dataAgendamento;
        } else {
          this.agendamentoRetorno = true;
          this.agendamento.agendamentoConsulta.retorno = true;
          this.mostrarTooltipRetorno = true;
          data = agendamentoRetorno;
          agendamento = agendamentoRetorno;
          agendamentoConsulta = agendamentoRetorno.agendamentoConsulta;
          dataAgendamento = agendamentoRetorno.dataAgendamento;

          this.pacienteService.BuscarPacientePorIdComConvenios(data.agendamentoConsulta.pacienteId)
            .then((res) => {
              const paciente = res.data;

              this.pacienteSelecionado = paciente.usarNomeSocialComoPrincipal
                ? paciente.nomeSocial
                : paciente.nomeCompleto;

              this.cpfPaciente = paciente.cpf;

              this.agendamento.agendamentoConsulta.telefone = paciente.contatos?.telefonePrincipal;

              if (paciente.convenios && paciente.convenios.length > 0) {
                this.options_convenio = paciente.convenios.map((c) => ({
                  value: c.convenioId,
                  text: c.nome,
                  periodoRetornoDias: c.periodoRetornoDias ?? 0,
                }));
              } else {
                this.options_convenio = [{ value: null, text: 'Não registrado', periodoRetornoDias: 0 }];
                this.options_plano = [{ value: null, text: 'Não registrado' }];
                this.agendamento.agendamentoConsulta.convenioId = null;
                this.agendamento.agendamentoConsulta.planoId = null;
              }

              this.desabilitarConvenio = !(paciente.convenios && paciente.convenios.length > 0);
            })
            .catch((erro) => {
              AlertaSimplesErro('Erro ao buscar paciente:', erro);
            });
        }

        if (agendamentoConsulta) {
          await this.triagemService.GetTriagemPorAgendamentoId(data.id)
            .then((res) => {
              if (res.status === 204) {
                this.desabilitarBotaoTriagem = false;
              } else if (res.status === 200) {
                this.desabilitarBotaoTriagem = true;
              }
            })
            .catch((error) => {
              this.desabilitarBotaoTriagem = false;
            });
        } else {
          this.desabilitarBotaoTriagem = true;
        }

        await this.buscarHorarios(
          this.idAgenda,
          DateHelper.formatarParaAnosMesDiaISO(dataAgendamento),
        );

        this.horarios.push({
          text: agendamento.horaAgendamento,
          value: agendamento.horaAgendamento,
        });

        if (agendamentoConsulta?.convenioId) {
          await this.preencherPlanos(agendamentoConsulta.convenioId);
          this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Convenio;

          if (agendamentoRetorno) {
            this.agendamento.agendamentoConsulta.convenioId = agendamentoConsulta.convenioId;
            this.agendamento.agendamentoConsulta.planoId = agendamentoConsulta.planoId;
            this.agendamento.agendamentoConsulta.periodoRetornoDias = agendamentoConsulta.periodoRetornoDias;
            this.agendamento.agendamentoConsulta.retorno = true;

            this.$nextTick(() => {
              this.agendamento.agendamentoConsulta.convenioId = agendamentoConsulta.convenioId;
              this.agendamento.agendamentoConsulta.planoId = agendamentoConsulta.planoId;
            });
          }
        } else {
          const temConvenioNoPaciente = this.options_convenio && this.options_convenio.length > 0 && this.options_convenio[0].value !== null;
          this.desabilitarConvenio = !temConvenioNoPaciente;
          this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
        }
        this.cpfPaciente = agendamentoConsulta?.paciente?.cpf;
        this.agendamento.tipoAgendamento = agendamento.tipoAgendamento;
        setTimeout(() => { }, 1);
        this.agendamento = {
          ...agendamento,
          agendamentoConsulta: agendamento.tipoAgendamento === TipoAgendamento.Compromisso
            ? new AgendamentoConsulta()
            : {
              ...agendamentoConsulta,
              paciente: agendamentoConsulta?.paciente ? { ...agendamentoConsulta.paciente } : undefined,
            },
          agendamentoCompromisso: agendamento.tipoAgendamento === TipoAgendamento.Consulta ? new AgendamentoCompromisso() : { ...agendamento.agendamentoCompromisso },
        };

        if (this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo) {
          const paciente = this.agendamento.agendamentoConsulta?.paciente || {} as any;
          const pacienteId = this.agendamento.agendamentoConsulta?.pacienteId || paciente?.id || 0;
          const telefone = this.agendamento.agendamentoConsulta?.telefone
            || paciente?.contato?.telefonePrincipal
            || paciente?.telefonePrincipal
            || '';

          this.pacientesSelecionadosColetivo = [
            {
              id: pacienteId,
              pacienteId,
              nomeCompleto: paciente?.nomeCompleto,
              nomeExibirSocial: paciente?.nomeExibirSocial || paciente?.nomeSocial,
              cadastroCompleto: paciente?.cadastroCompleto,
              telefone,
              convenioId: this.agendamento.agendamentoConsulta?.convenioId || null,
              planoId: this.agendamento.agendamentoConsulta?.planoId || null,
              tipoConsultaId: this.agendamento.agendamentoConsulta?.tipoConsultaId || this.agendamento.tipoConsultaId || 0,
              situacaoAgendamento: this.agendamento.situacaoAgendamento || SituacaoAgendamento.Marcado,
              retorno: !!this.agendamento.agendamentoConsulta?.retorno,
              agendamentoConfirmado: !!this.agendamento.agendamentoConfirmado,
              observacao: this.agendamento.observacaoAgendamento || '',
              orientacoesPaciente: this.agendamento.orientacoesPaciente || '',
            },
          ];

          if (pacienteId) {
            try {
              const respostaPaciente = await this.pacienteService.BuscarPacientePorIdComConvenios(pacienteId);
              const pacienteData = respostaPaciente?.data;
              if (pacienteData?.convenios && pacienteData.convenios.length > 0) {
                this.pacientesSelecionadosColetivo[0].conveniosDisponiveis = pacienteData.convenios.map((c) => ({
                  value: c.convenioId,
                  text: c.nome,
                  periodoRetornoDias: c.periodoRetornoDias ?? 0,
                }));
              } else {
                this.pacientesSelecionadosColetivo[0].conveniosDisponiveis = [];
              }
              this.pacientesSelecionadosColetivo[0].cadastroCompleto = pacienteData?.cadastroCompleto;
            } catch (error) {
              console.error('Erro ao buscar convênios do paciente (edição coletivo):', error);
            }
          }
        } else {
          this.pacientesSelecionadosColetivo = [];
        }

        this.date = DateHelper.formataParaAnoMesDia(dataAgendamento);
        this.agendamento.tipoConsultaId = this.agendamento.agendamentoConsulta?.tipoConsultaId;
        this.agendamento.dataAgendamento = DateHelper.formataParaDiaMesAno(dataAgendamento);
        this.carregando = false;

        // Executa validação inicial para destacar campos obrigatórios
        this.$nextTick(() => {
          this.executarValidacaoInicial();
        });
      } catch (error) {
        AlertaSimplesErro('Aviso:', error);
        this.fecharModal();
      }
    },
    async obterUltimaConsultaPaciente() {
      this.ultimaConsultaPaciente = await this.atendimentoService.ObterUltimaConsultaPaciente(this.idPacienteSelecionado);
      const semDataUltimaConsulta = '01/01/0001';
      if (this.ultimaConsultaPaciente.data !== semDataUltimaConsulta) {
        this.ultimaConsultaPaciente = this.ultimaConsultaPaciente.data;
      } else {
        this.ultimaConsultaPaciente = 'Não há registros de consultas anteriores para o paciente.';
      }
    },
    fecharModal() {
      this.horarios = [];
      this.agendamento = new Agendamento();
      this.preAgendamento = false;
      this.modalAberto = false;
      this.carregando = false;
      this.editarAgendamento = false;
      this.agendamentoRetorno = false;
      this.pacientesSelecionadosColetivo = [];
      this.pacientesExcluidosColetivo = [];
      this.pacientesExcluidosColetivoBanco = [];
      this.isAdicionarPacienteColetivo = false;
      this.modalObservacoes = false;
      this.pacienteObservacaoAtual = {} as any;
      this.indexPacienteObservacao = -1;
      this.cpfPaciente = '';
      this.pacienteSelecionado = '';
      this.idPacienteSelecionado = 0;
      this.filaPacientesAgendamentosEncontrados = [];
      this.pacienteAgendamentoEncontradoAtual = null;
      this.pacienteIdModalAgendamentos = 0;
      this.nomePacienteModalAgendamentos = '';
      this.validacaoInicialExecutada = false;
      this.tipoAgendamentoAnterior = null;
      this.ignorarConfirmacaoTrocaTipo = false;
      this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
      this.limparCamposPaciente();
    },
    // #endregion
    // #region <Funções Paciente>
    async carregarDadosPaciente(pacienteId: string) {
      this.pacienteService
        .BuscarPacientePorIdComConvenios(pacienteId)
        .then((response) => {
          const paciente = response.data;
          if (paciente) {
            this.agendamento.agendamentoConsulta.telefone = paciente.contato?.telefonePrincipal;
            this.agendamento.agendamentoConsulta.email = paciente.contato?.emailPrincipal;
            this.cpfPaciente = paciente.cpf;
            if (paciente.convenios && paciente.convenios.length > 0) {
              this.options_convenio = paciente.convenios.map((c) => ({
                value: c.convenioId,
                text: c.nome,
                periodoRetornoDias: c.periodoRetornoDias,
              }));
            } else {
              this.options_convenio = [{ value: null, text: 'Não registrado' }];
              this.options_plano = [{ value: null, text: 'Não registrado' }];
              this.agendamento.agendamentoConsulta.convenioId = null;
              this.agendamento.agendamentoConsulta.planoId = null;
            }
          }
        })
        .catch((error) => { });
    },
    async atualizarDadosPaciente() {
      if (this.agendamento.agendamentoConsulta.pacienteId !== 0) {
        try {
          await this.carregarDadosPaciente(this.agendamento.agendamentoConsulta.pacienteId);
        } catch (error) {
          AlertaSimplesErro('Erro ao atualizar dados do paciente:', error);
        }
      }
    },
    alterarPreAgendamento() {
      if (this.preAgendamento) {
        this.limparCamposPaciente();
        this.preencherConvenios();
        this.options_plano = [];
      } else {
        this.verificarSePacienteTemConvenioCadastrado();
        this.limparCamposPaciente();
      }
    },
    async getPacientes() {
      this.carregando = true;
      await this.pacienteService
        .BuscarPaciente()
        .then(
          (res) => {
            this.pacientes = res.data;
            (this as any).pacientes.forEach((paciente) => {
              const temDataNascimento = paciente.dataNascimento
                && paciente.dataNascimento !== '0001-01-01T00:00:00'
                && paciente.dataNascimento !== '0001-01-01';

              paciente.idade = temDataNascimento
                ? DateHelper.calculaIdadePorExtenso(paciente.dataNascimento)
                : 'Não informada';
              paciente.dataNascimento = temDataNascimento
                ? DateHelper.formataParaDiaMesAno(paciente.dataNascimento)
                : 'Não informada';
            });
          },
          (err) => {
            AlertaSimplesErro('Aviso:', err);
          },
        );
      this.carregando = false;
    },
    async atualizarPacientesColetivoBanco() {
      if (this.editarAgendamento || this.agendamento.tipoAgendamento !== TipoAgendamento.Coletivo) {
        this.pacientesExcluidosColetivoBanco = [];
        return;
      }

      const dataBase = this.date ? DateHelper.formataParaAnoMesDia(this.date) : '';
      const horaBase = this.agendamento.horaAgendamento;
      if (!dataBase || !horaBase) {
        this.pacientesExcluidosColetivoBanco = [];
        return;
      }

      try {
        const respostaAgendamentos = await this.agendamentoService.BuscarAgendamentos(
          this.idAgenda,
          dataBase,
          '',
          '',
          1000,
          1,
        );

        const itens = respostaAgendamentos?.data?.itens || respostaAgendamentos?.data?.items || [];
        const pacientesIds = itens
          .filter((ag: any) => {
            const tipo = ag.tipoAgendamento;
            const isColetivo = tipo === 'Coletivo'
              || tipo === TipoAgendamento.Coletivo
              || tipo === 2;
            const mesmoHorario = ag.horaAgendamento === horaBase;
            return isColetivo && mesmoHorario;
          })
          .map((ag: any) => ag?.agendamentoConsulta?.pacienteId
            || ag?.paciente?.id
            || ag?.pacienteId
            || '')
          .map((id: any) => `${id}`)
          .filter((id: string) => id && id !== '0' && id !== 'null' && id !== 'undefined');

        this.pacientesExcluidosColetivoBanco = Array.from(new Set(pacientesIds));
      } catch (error) {
        console.warn('Erro ao buscar pacientes coletivos no horário:', error);
        this.pacientesExcluidosColetivoBanco = [];
      }
    },
    abrirModalEditarPaciente(paciente: any) {
      if (paciente && paciente.id) {
        (this.$refs.modalEditarPaciente as any).abrirModal(paciente.id);
      }
    },
    abrirModalCriarPaciente() {
      (this.$refs.modalCriarPaciente as any).abrirModal();
    },
    async onPacienteEditado() {
      await this.getPacientes();
    },
    async onPacienteCriado(paciente: any) {
      await this.getPacientes();

      if (paciente && paciente.id) {
        this.pacienteSelecionado = paciente.usarNomeSocialComoPrincipal
          ? paciente.nomeExibirSocial || paciente.nomeSocial
          : paciente.nomeCompleto;
        this.idPacienteSelecionado = paciente.id;
        this.agendamento.agendamentoConsulta.pacienteId = paciente.id;

        await this.atualizarDadosPaciente();

        await this.$nextTick();
        if (this.$refs.observer) {
          await (this.$refs.observer as any).validate();
        }
        this.obterUltimaConsultaPaciente();
      }
    },
    // #endregion
    // #region <Funções do componente de Situação do Agendamento>
    corDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento)!.color;
    },
    iconeDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento)!.icon;
    },
    textDaSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      return this.opcoesSituacaoAgendamento.find((x) => x.value === situacaoAgendamento)!.text;
    },
    // #endregion
    async dataEstaBloqueada(dataParaVerificar: string): Promise<boolean> {
      try {
        const dataParaVerificarTipada: Date = new Date(`${dataParaVerificar}T00:00:00`);

        const bloqueioEncontrado = this.datasBloqueadas.find(
          (periodo) => dataParaVerificarTipada >= new Date(periodo.dataInicio)
            && dataParaVerificarTipada <= new Date(periodo.dataFim),
        );

        const feriadoEncontrado = this.feriados.find(
          (feriado) => new Date(feriado.data).getDate() === dataParaVerificarTipada.getDate()
            && new Date(feriado.data).getMonth() === dataParaVerificarTipada.getMonth(),
        );

        const diaSemana = dataParaVerificarTipada.getDay();

        if (!this.agenda.listaHorarios.find((x) => x.diaSemana === diaSemana)) {
          MensagemMixin(8000, 'error', 'Este dia não possui horário cadastrado!');
          return true;
        }

        if (bloqueioEncontrado) {
          MensagemMixin(8000, 'error', 'Existe um bloqueio para esta data!');
          return true;
        }
        if (feriadoEncontrado) {
          MensagemMixin(8000, 'error', 'O feriado está marcado para esta data!');
          return true;
        }

        return false;
      } catch (error) {
        console.error(error);
      }
    },
    desabilitarDatas(dataParaVerificar: string): boolean {
      const data: Date = new Date(`${dataParaVerificar}T00:00:00`);

      const diaSemana = data.getDay();

      if (!this.agenda.listaHorarios.find((x) => x.diaSemana === diaSemana)) {
        return false;
      }

      if (this.datasBloqueadas.some((periodo) => data >= new Date(periodo.dataInicio)
        && data <= new Date(periodo.dataFim))) {
        return false;
      }

      if (this.feriados.some((feriado) => feriado.data === `${dataParaVerificar}T00:00:00`)) {
        return false;
      }

      return true;
    },
    parseDate(date: string) {
      if (!date) {
        return '';
      }

      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    async buscarProximaDataDisponivel(idAgenda: number) {
      try {
        const resposta = await this.agendamentoService.BuscarProximaDataDisponivel(idAgenda);
        return resposta.data;
      } catch (error) {
        AlertaSimplesErro('Aviso:', error);
        return null;
      }
    },
    // #region <Funções de Limpeza de Campos>
    limparCamposPaciente() {
      this.agendamento.agendamentoConsulta.telefone = '';
      this.agendamento.agendamentoConsulta.email = '';
      this.agendamento.agendamentoConsulta.pacienteId = '';
      this.agendamento.agendamentoConsulta.convenioId = null;
      this.agendamento.agendamentoConsulta.planoId = null;
      this.cpfPaciente = '';
      this.limparDadosPacienteSessaoArmazenamento();
    },
    // #endregion
    async preencherConvenios() {
      try {
        const resposta = await this.convenioService.getAllSelect();
        this.options_convenio = resposta.data.map((c: any) => ({
          value: c.value,
          text: c.text,
          periodoRetornoDias: c.periodoRetorno ?? 0,
        }));
      } catch (error) {
        console.error('Erro ao preencher convênios:', error);
      }
    },
    async preencherPlanos(convenioId: number) {
      this.options_plano = [];
      if (convenioId) {
        const resposta = await this.planoService.getAllSelect(convenioId);
        this.options_plano = resposta.data;
      }
    },
    mudarPlanos() {
      if (!this.agendamentoRetorno) {
        this.agendamento.agendamentoConsulta.retorno = false;
      }
      this.preencherPlanos(this.agendamento.agendamentoConsulta.convenioId).then(() => {
        if (!this.options_plano || this.options_plano.length === 0) {
          this.agendamento.agendamentoConsulta.planoId = null;
        }
        const convenioSelecionado = this.options_convenio.find((c) => c.value === this.agendamento.agendamentoConsulta.convenioId);
        if (convenioSelecionado) {
          this.agendamento.agendamentoConsulta.periodoRetornoDias = convenioSelecionado.periodoRetornoDias;
          this.mostrarTooltipRetorno = true;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        } else {
          this.agendamento.agendamentoConsulta.periodoRetornoDias = 0;
          this.mostrarTooltipRetorno = true;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      });
    },
    async preencherTipoConsulta(idAgenda: number) {
      try {
        const resposta = await this.tipoConsultaService.getAllSelect(idAgenda);
        this.options_consulta = resposta.data;
      } catch (error) {
        if (error.response.status) {
          console.error(error.response.status);
          console.error(error.response.data);
          return;
        }

        AlertaSimplesErro('Error na consulta', error);
      }
    },
    mudarTipoAgendamento() {
      if (this.agendamento.tipoAgendamento === TipoAgendamento.Compromisso
        || this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo) {
        this.ocultarRadioTipoPagamento = true;
        this.options_plano = [];
        this.limparCamposPaciente();
        this.$set(this.agendamento, 'agendamentoConsulta', new AgendamentoConsulta());
        this.agendamento.agendamentoConsulta.tipoConsultaId = undefined;
      } else {
        this.ocultarRadioTipoPagamento = false;
        this.$set(this.agendamento, 'agendamentoCompromisso', new AgendamentoCompromisso());
      }

      this.carregarDadosDoPacienteSelecionado();
    },
    async onChangeTipoAgendamento(novoTipo: TipoAgendamento) {
      if (this.tipoAgendamentoAnterior === null) {
        this.limparDadosTrocaTipo(novoTipo);
        this.mudarTipoAgendamento();
        this.tipoAgendamentoAnterior = novoTipo;
        return;
      }

      if (novoTipo === this.tipoAgendamentoAnterior) {
        this.mudarTipoAgendamento();
        return;
      }

      const tipoParaValidar = this.tipoAgendamentoAnterior ?? this.agendamento.tipoAgendamento;
      const temDados = this.temDadosPreenchidosParaTroca(tipoParaValidar as TipoAgendamento);
      if (!temDados) {
        this.limparDadosTrocaTipo(novoTipo);
        this.mudarTipoAgendamento();
        this.tipoAgendamentoAnterior = novoTipo;
        return;
      }

      const confirmar = await AlertaPerguntaSimOuNaoBooleano(
        'Confirmação',
        'Ao trocar o tipo de agendamento, as informações preenchidas no agendamento atual serão perdidas. Deseja continuar?',
      );

      if (confirmar) {
        this.limparDadosTrocaTipo(novoTipo);
        this.mudarTipoAgendamento();
        this.tipoAgendamentoAnterior = novoTipo;
      } else {
        this.agendamento.tipoAgendamento = this.tipoAgendamentoAnterior;
      }
    },
    temDadosPreenchidosParaTroca(tipoAtual: TipoAgendamento) {
      if (this.agendamento.dataAgendamento || this.agendamento.horaAgendamento || this.agendamento.duracaoAgendamento) {
        return true;
      }

      if (this.agendamento.observacaoAgendamento || this.agendamento.orientacoesPaciente) {
        return true;
      }

      if (tipoAtual === TipoAgendamento.Coletivo) {
        return !!(this.pacientesSelecionadosColetivo && this.pacientesSelecionadosColetivo.length > 0);
      }

      if (tipoAtual === TipoAgendamento.Compromisso) {
        return !!this.agendamento.agendamentoCompromisso?.descricao;
      }

      if (tipoAtual === TipoAgendamento.Consulta) {
        if (this.pacienteSelecionado || this.idPacienteSelecionado || this.cpfPaciente) {
          return true;
        }

        if (this.agendamento.agendamentoConsulta) {
          const consulta = this.agendamento.agendamentoConsulta;
          if (
            consulta.tipoConsultaId
            || consulta.email
            || consulta.telefone
            || consulta.pacienteId
            || consulta.convenioId
            || consulta.planoId
            || consulta.retorno
          ) {
            return true;
          }

          if (consulta.paciente) {
            const paciente = consulta.paciente as any;
            if (paciente.nomeCompleto || paciente.dataNascimento) {
              return true;
            }
          }
        }
      }

      return false;
    },
    limparDadosTrocaTipo(novoTipo: TipoAgendamento) {
      const agendaId = this.agendamento.agendaId || this.idAgenda;

      this.agendamento = new Agendamento();
      this.agendamento.agendaId = agendaId;
      this.agendamento.tipoAgendamento = novoTipo;
      this.agendamento.situacaoAgendamento = SituacaoAgendamento.Marcado;

      this.date = '' as any;
      this.horarios = [];
      this.horariosAgenda = [];
      this.pacienteSelecionado = '';
      this.idPacienteSelecionado = 0;
      this.cpfPaciente = '';
      this.ultimaConsultaPaciente = '';
      this.pacientesSelecionadosColetivo = [];
      this.pacientesExcluidosColetivo = [];
      this.pacientesExcluidosColetivoBanco = [];
    },
    async buscarHorarios(idAgenda: number, data: string): Promise<boolean> {
      this.horarios = [];
      let possuiHorarios = false;

      try {
        const resposta = await this.agendamentoService.GetAgendamentoHorarios(idAgenda, DateHelper.formatarParaAnosMesDiaISO(data));
        this.horariosAgenda = resposta.data;
        let agendamentosExistentes = [];
        try {
          const dataFormatadaBusca = DateHelper.formataParaAnoMesDia(data);
          const respostaAgendamentos = await this.agendamentoService.BuscarAgendamentos(
            idAgenda,
            dataFormatadaBusca,
            '',
            '',
            1000,
            1,
          );

          if (respostaAgendamentos?.data?.items) {
            agendamentosExistentes = respostaAgendamentos.data.items.filter((ag: any) => {
              const tipo = ag.tipoAgendamento;
              return (
                tipo === 'Consulta'
                || tipo === 'Compromisso'
                || tipo === TipoAgendamento.Consulta
                || tipo === TipoAgendamento.Compromisso
              );
            });
          } else {
            console.warn('⚠️ Nenhum agendamento encontrado ou estrutura de resposta inesperada');
          }
        } catch (error) {
          console.warn('⚠️ Erro ao buscar agendamentos existentes para filtrar horários:', error);
        }
        const horariosOcupados = new Set(
          agendamentosExistentes.map((ag: any) => ag.horaAgendamento),
        );
        resposta.data.forEach((listaHorarios: { horarios: any[] }) => {
          const horariosDisponiveis = listaHorarios.horarios.filter(
            (horario: { value: string }) => !horariosOcupados.has(horario.value),
          );
          this.horarios = this.horarios.concat(horariosDisponiveis);
        });

        if (this.horarios.length > 0) {
          possuiHorarios = true;
          this.agendamento.horaAgendamento = this.horarios[0].value;
          const primeiraListaComHorario = this.horariosAgenda.find((lista: any) => lista.horarios.some((h: any) => h.value === this.horarios[0].value));
          if (primeiraListaComHorario) {
            this.agendamento.duracaoAgendamento = primeiraListaComHorario.duracaoAgendamento;
          }
        } else if (this.horariosAgenda.length > 0) {
          possuiHorarios = true;
          this.agendamento.horaAgendamento = this.horariosAgenda[0].horarios[0].value;
          this.agendamento.duracaoAgendamento = this.horariosAgenda[0].duracaoAgendamento;
        }

        return possuiHorarios;
      } catch (error) {
        possuiHorarios = false;
        this.agendamento.horaAgendamento = '';
        this.agendamento.duracaoAgendamento = '';
        AlertaSimplesErro('Aviso:', error);
        return possuiHorarios;
      }
    },
    preencherDuracaoAgendamento() {
      const horarioAgendaEncontrado = this.horariosAgenda.find((listaHorarios: { horarios: { value: string; }[]; }) => listaHorarios.horarios
        .some((hora: { value: string }) => hora.value === this.agendamento.horaAgendamento));

      if (horarioAgendaEncontrado) {
        this.agendamento.duracaoAgendamento = horarioAgendaEncontrado.duracaoAgendamento;
      }
    },
    async salvar(): Promise<boolean> {
      const dateBackup = this.date;
      this.agendamento.agendamentoConsulta.tipoConsultaId = this.agendamento.tipoConsultaId;
      const situacaoParaValidar = this.isEdicaoColetivo && this.pacientesSelecionadosColetivo?.length
        ? this.pacientesSelecionadosColetivo[0].situacaoAgendamento
        : this.agendamento.situacaoAgendamento;

      if (situacaoParaValidar === SituacaoAgendamento.Cancelado
        && (this.agendamento.tipoAgendamento === TipoAgendamento.Consulta
          || this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo)) {
        const confirmarCancelamento = !!await AlertaPerguntaSimOuNaoBooleano(
          'Deseja realmente cancelar esse agendamento?',
          'O agendamento será cancelado, essa ação é irreversível!',
        );
        if (confirmarCancelamento) {
          const motivoCancelamentoAgendamento = await new Promise<string>((resolve) => {
            this.confirmaCancelamentoAgendamento = true;
            this.pendingCancelamentoResolve = resolve;
          });
          this.agendamento.motivoCancelamentoAgendamento = motivoCancelamentoAgendamento;
          this.agendamento.situacaoAgendamento = situacaoParaValidar;
        } else {
          this.confirmaCancelamentoAgendamento = false;
          return false;
        }
      }
      const formularioValido = await (this.$refs.observer as any).validate();

      if (!formularioValido) {
        return false;
      }

      try {
        const dataFormatada = DateHelper.formataParaAnoMesDia(this.date);

        const normalizarData = (dataStr: string): Date => {
          if (!dataStr) return new Date();
          let data: Date;

          if (/^\d{2}\/\d{2}\/\d{4}$/.test(dataStr)) {
            const [dia, mes, ano] = dataStr.split('/');
            data = new Date(Number(ano), Number(mes) - 1, Number(dia));
          } else if (/^\d{4}-\d{2}-\d{2}$/.test(dataStr)) {
            const [ano, mes, dia] = dataStr.split('-');
            data = new Date(Number(ano), Number(mes) - 1, Number(dia));
          } else {
            data = new Date(dataStr);
          }

          if (Number.isNaN(data.getTime())) {
            console.warn('Data inválida:', dataStr);
            return new Date();
          }

          return new Date(data.getFullYear(), data.getMonth(), data.getDate());
        };

        const dataVerificadaNormalizada = normalizarData(dataFormatada);
        let bloqueioEncontrado = false;

        if (this.agenda && this.agenda.listaBloqueios && this.agenda.listaBloqueios.length > 0) {
          bloqueioEncontrado = this.agenda.listaBloqueios.some((bloqueio) => {
            const dataInicioBloqueio = normalizarData(bloqueio.dataInicio);
            const dataFimBloqueio = normalizarData(bloqueio.dataFim);
            const dataVerificadaTimestamp = dataVerificadaNormalizada.getTime();
            const inicioTimestamp = dataInicioBloqueio.getTime();
            const fimTimestamp = dataFimBloqueio.getTime();

            const hoje = normalizarData(new Date().toISOString().substr(0, 10));
            const bloqueioAindaAtivo = fimTimestamp >= hoje.getTime();

            if (bloqueioAindaAtivo) {
              return dataVerificadaTimestamp >= inicioTimestamp
                && dataVerificadaTimestamp <= fimTimestamp;
            }

            return false;
          });
        }

        // SEMPRE carrega a agenda completa do backend para garantir que verifica TODOS os bloqueios ativos
        if (!bloqueioEncontrado) {
          this.carregando = true;
          try {
            const agendaCompleta = await this.agendaService.Get(this.idAgenda);
            if (agendaCompleta && agendaCompleta.data && agendaCompleta.data.listaBloqueios) {
              bloqueioEncontrado = agendaCompleta.data.listaBloqueios.some((bloqueio: any) => {
                const dataInicioBloqueio = normalizarData(bloqueio.dataInicio);
                const dataFimBloqueio = normalizarData(bloqueio.dataFim);
                const dataVerificadaTimestamp = dataVerificadaNormalizada.getTime();
                const inicioTimestamp = dataInicioBloqueio.getTime();
                const fimTimestamp = dataFimBloqueio.getTime();
                const hoje = normalizarData(new Date().toISOString().substr(0, 10));
                const bloqueioAindaAtivo = fimTimestamp >= hoje.getTime();

                if (bloqueioAindaAtivo) {
                  return dataVerificadaTimestamp >= inicioTimestamp
                    && dataVerificadaTimestamp <= fimTimestamp;
                }

                return false;
              });
            }
          } catch (error) {
            console.warn('Erro ao carregar agenda completa para validação de bloqueios:', error);
          } finally {
            this.carregando = false;
          }
        }

        if (bloqueioEncontrado) {
          AlertaSimples('Erro', 'Este dia foi bloqueado pela agenda e não permite agendamentos!', 'error');
          this.carregando = false;
          return false;
        }

        if (await this.dataEstaBloqueada(DateHelper.formataParaAnoMesDia(this.date))) {
          return false;
        }

        const horariosReservados: IHorarioReservado[] = await this.verificarSeExisteConflitoDeAgenda(dataFormatada, this.agendamento.horaAgendamento);
        const horariosReservadosAgendaAtual: IHorarioReservado[] = horariosReservados.filter((item: IHorarioReservado) => item.agendaId === this.idAgenda);

        const feriados: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'FERIADO');
        if (feriados && feriados.length > 0) {
          AlertaSimples('Erro', `Este dia está registrado como feriado pela agenda '${feriados[0].nomeAgenda}' e não permite agendamentos!`, 'error');
          this.carregando = false;
          return false;
        }

        const bloqueiosHorario: IHorarioReservado[] = horariosReservadosAgendaAtual.filter((item: IHorarioReservado) => item.tipo === 'BLOQUEIO_HORARIO');
        if (bloqueiosHorario && bloqueiosHorario.length > 0) {
          AlertaSimples('Erro', 'Este horário não está disponível para agendamentos. Há um bloqueio de horário configurado. Escolha outro horário ou remova o bloqueio primeiro.', 'error');
          this.carregando = false;
          return false;
        }

        const dataAgendamentoBase = this.date || this.agendamento.dataAgendamento;
        if (!dataAgendamentoBase) {
          AlertaSimples('Erro', 'Data do agendamento inválida.', 'error');
          this.carregando = false;
          return false;
        }
        const dataAgendamentoIso = dataAgendamentoBase.includes('/')
          ? DateHelper.formatarParaAnosMesDiaSubstring(dataAgendamentoBase)
          : DateHelper.formataParaAnoMesDia(dataAgendamentoBase);

        this.agendamento.dataAgendamento = dataAgendamentoIso;
        this.carregando = true;

        let foiConvertidoParaColetivo = false;

        if (this.agendamento.tipoAgendamento === TipoAgendamento.Consulta) {
          try {
            const dataFormatadaBusca = DateHelper.formataParaAnoMesDia(this.date);
            const respostaAgendamentos = await this.agendamentoService.BuscarAgendamentos(
              this.idAgenda,
              dataFormatadaBusca,
              '',
              '',
              1000,
              1,
            );

            if (respostaAgendamentos?.data?.itens) {
              const agendamentosColetivosNoHorario = respostaAgendamentos.data.itens.filter(
                (ag: any) => {
                  const isColetivo = ag.tipoAgendamento === 'Coletivo' || ag.tipoAgendamento === TipoAgendamento.Coletivo || ag.tipoAgendamento === 2;
                  const mesmoHorario = ag.horaAgendamento === this.agendamento.horaAgendamento;
                  return isColetivo && mesmoHorario;
                },
              );

              if (agendamentosColetivosNoHorario.length > 0) {
                const confirmar = await AlertaPerguntaSimOuNaoBooleanoHtml(
                  `Já existe um agendamento coletivo
                  neste horário (<strong>${this.agendamento.horaAgendamento}</strong>) com <strong>${agendamentosColetivosNoHorario.length} paciente(s) agendado(s).</strong>

                  Se você continuar, o paciente selecionado será <strong>adicionado ao agendamento coletivo. Não será criado um agendamento individual.</strong>

                  Deseja continuar?`,
                  'Agendamento Coletivo Detectado',
                );

                if (!confirmar) {
                  this.carregando = false;
                  return false;
                }

                foiConvertidoParaColetivo = true;
                this.agendamento.tipoAgendamento = TipoAgendamento.Coletivo;
                if (this.agendamento.agendamentoConsulta) {
                  this.agendamento.agendamentoConsulta.paciente = undefined;
                }
                this.agendamento.agendamentoCompromisso = undefined;
              }
            }
          } catch (error) {
            console.warn('Erro ao verificar agendamentos coletivos existentes:', error);
          }
        }

        if (this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo
          && !this.editarAgendamento
          && !foiConvertidoParaColetivo) {
          try {
            const dataFormatadaBusca = DateHelper.formataParaAnoMesDia(this.date);
            const respostaAgendamentos = await this.agendamentoService.BuscarAgendamentos(
              this.idAgenda,
              dataFormatadaBusca,
              '',
              '',
              1000,
              1,
            );

            if (respostaAgendamentos?.data?.itens) {
              const agendamentosColetivosNoHorario = respostaAgendamentos.data.itens.filter(
                (ag: any) => {
                  const isColetivo = ag.tipoAgendamento === 'Coletivo'
                    || ag.tipoAgendamento === TipoAgendamento.Coletivo
                    || ag.tipoAgendamento === 2;
                  const mesmoHorario = ag.horaAgendamento === this.agendamento.horaAgendamento;
                  return isColetivo && mesmoHorario;
                },
              );

              if (agendamentosColetivosNoHorario.length > 0) {
                const confirmar = await AlertaPerguntaSimOuNaoBooleanoHtml(
                  `Já existe um agendamento coletivo neste horário
                  (<strong>${this.agendamento.horaAgendamento}</strong>) com <strong>${agendamentosColetivosNoHorario.length} paciente(s) agendado(s).</strong>

                  Se você continuar, o paciente selecionado será <strong>adicionado ao agendamento coletivo. Não será criado um agendamento individual.</strong>

                  <strong><br><br>Deseja continuar?</strong>`,
                  'Agendamento Coletivo Detectado',
                );

                if (!confirmar) {
                  this.carregando = false;
                  return false;
                }
              }
            }
          } catch (error) {
            console.warn('Erro ao verificar agendamentos coletivos existentes:', error);
          }
        }

        // Se for um agendamento de retorno (sem salvar diretamente)
        if (this.agendamentoRetorno) {
          this.$emit('retorno', this.agendamento);
          this.fecharModal();
          return true;
        }

        if (this.agendamento.tipoAgendamento === TipoAgendamento.Consulta && !foiConvertidoParaColetivo) {
          if (!this.preAgendamento) {
            this.agendamento.agendamentoConsulta.paciente = undefined;
          }

          this.agendamento.agendamentoCompromisso = undefined;

          if (this.preAgendamento) {
            this.agendamento.agendamentoConsulta.pacienteId = 0;
            if (!this.agendamento.agendamentoConsulta.paciente.contato) {
              this.agendamento.agendamentoConsulta.paciente.contato = {
                emailPrincipal: '',
                telefonePrincipal: '',
              };
            }
            this.agendamento.agendamentoConsulta.paciente.contato.telefonePrincipal = this.agendamento.agendamentoConsulta.telefone;
            this.agendamento.agendamentoConsulta.paciente.contato.emailPrincipal = this.agendamento.agendamentoConsulta.email || '';

            this.agendamento.agendamentoConsulta.paciente.convenios = [
              {
                convenioId: this.agendamento.agendamentoConsulta.convenioId,
                planoId: this.agendamento.agendamentoConsulta.planoId || null,
                principal: true,
              },
            ];
          }
        } else if (this.agendamento.tipoAgendamento === TipoAgendamento.Compromisso) {
          this.agendamento.agendamentoConsulta = undefined;
        } else if (this.agendamento.tipoAgendamento === TipoAgendamento.Coletivo) {
          if (this.editarAgendamento) {
            const pacienteEditado = this.pacientesSelecionadosColetivo[0];

            if (!pacienteEditado) {
              AlertaSimples('Erro', 'Nenhum paciente selecionado para edição.', 'error');
              this.carregando = false;
              return false;
            }

            if (!this.agendamento.agendamentoConsulta) {
              this.agendamento.agendamentoConsulta = new AgendamentoConsulta();
            }

            this.agendamento.agendamentoCompromisso = undefined;
            this.agendamento.tipoAgendamento = TipoAgendamento.Coletivo;
            this.agendamento.agendamentoConsulta.pacienteId = pacienteEditado.pacienteId || this.agendamento.agendamentoConsulta.pacienteId;
            this.agendamento.agendamentoConsulta.tipoConsultaId = pacienteEditado.tipoConsultaId || this.agendamento.tipoConsultaId;
            this.agendamento.agendamentoConsulta.telefone = pacienteEditado.telefone || this.agendamento.agendamentoConsulta.telefone || '';
            this.agendamento.agendamentoConsulta.convenioId = pacienteEditado.convenioId || null;
            this.agendamento.agendamentoConsulta.planoId = pacienteEditado.planoId || null;
            this.agendamento.agendamentoConsulta.retorno = !!pacienteEditado.retorno;
            this.agendamento.agendamentoConsulta.paciente = undefined;
            this.agendamento.tipoConsultaId = pacienteEditado.tipoConsultaId || this.agendamento.tipoConsultaId;
            this.agendamento.situacaoAgendamento = pacienteEditado.situacaoAgendamento ?? this.agendamento.situacaoAgendamento;
            this.agendamento.agendamentoConfirmado = !!pacienteEditado.agendamentoConfirmado;
            this.agendamento.observacaoAgendamento = pacienteEditado.observacao || this.agendamento.observacaoAgendamento || '';
            this.agendamento.orientacoesPaciente = pacienteEditado.orientacoesPaciente || this.agendamento.orientacoesPaciente || '';

            try {
              await this.agendamentoService.Put(this.agendamento.id, this.agendamento);
              MensagemMixin(3000, 'success', 'Agendamento coletivo editado com sucesso.');
              this.carregando = false;
              this.fecharModal();
              this.$emit('atualizaCalendario');
              return true;
            } catch (error) {
              AlertaSimplesErro('Erro ao editar agendamento coletivo:', error);
              this.carregando = false;
              return false;
            }
          }
          try {
            let pacientesParaCriar = [];
            if (!this.pacientesSelecionadosColetivo || this.pacientesSelecionadosColetivo.length === 0) {
              pacientesParaCriar = [{
                pacienteId: this.agendamento.agendamentoConsulta.pacienteId,
                tipoConsultaId: this.agendamento.tipoConsultaId || this.agendamento.agendamentoConsulta.tipoConsultaId,
                telefone: this.agendamento.agendamentoConsulta.telefone || '',
                email: this.agendamento.agendamentoConsulta.email || '',
                convenioId: this.agendamento.agendamentoConsulta.convenioId || null,
                planoId: this.agendamento.agendamentoConsulta.planoId || null,
                retorno: this.agendamento.agendamentoConsulta.retorno || false,
                situacaoAgendamento: this.agendamento.situacaoAgendamento || SituacaoAgendamento.Marcado,
                agendamentoConfirmado: this.agendamento.agendamentoConfirmado || false,
                observacao: this.agendamento.observacaoAgendamento || '',
                orientacoesPaciente: this.agendamento.orientacoesPaciente || '',
              }];
            } else {
              const pacientesSemTipoConsulta = this.pacientesSelecionadosColetivo.filter(
                (p) => !p.tipoConsultaId || p.tipoConsultaId === 0,
              );

              if (pacientesSemTipoConsulta.length > 0) {
                AlertaSimples('Erro', 'Todos os pacientes devem ter o campo "Tipo de Consulta" preenchido!', 'error');
                this.carregando = false;
                return false;
              }
              pacientesParaCriar = this.pacientesSelecionadosColetivo;
            }

            const promises = pacientesParaCriar.map(async (pacienteColetivo) => {
              const novoAgendamento = new Agendamento();
              novoAgendamento.agendaId = this.agendamento.agendaId;
              novoAgendamento.tipoAgendamento = TipoAgendamento.Coletivo;
              novoAgendamento.dataAgendamento = dataAgendamentoIso;
              novoAgendamento.horaAgendamento = this.agendamento.horaAgendamento;
              novoAgendamento.duracaoAgendamento = this.agendamento.duracaoAgendamento;
              novoAgendamento.observacaoAgendamento = pacienteColetivo.observacao || this.agendamento.observacaoAgendamento;
              novoAgendamento.orientacoesPaciente = pacienteColetivo.orientacoesPaciente || this.agendamento.orientacoesPaciente;
              novoAgendamento.situacaoAgendamento = pacienteColetivo.situacaoAgendamento || SituacaoAgendamento.Marcado;
              novoAgendamento.agendamentoConfirmado = pacienteColetivo.agendamentoConfirmado || false;
              novoAgendamento.agendamentoConsulta = new AgendamentoConsulta();
              novoAgendamento.agendamentoConsulta.paciente = undefined;
              novoAgendamento.agendamentoConsulta.pacienteId = pacienteColetivo.pacienteId;
              novoAgendamento.agendamentoConsulta.tipoConsultaId = pacienteColetivo.tipoConsultaId || this.agendamento.tipoConsultaId;
              novoAgendamento.agendamentoConsulta.telefone = pacienteColetivo.telefone || '';
              novoAgendamento.agendamentoConsulta.email = pacienteColetivo.email || '';
              novoAgendamento.agendamentoConsulta.convenioId = pacienteColetivo.convenioId || null;
              novoAgendamento.agendamentoConsulta.planoId = pacienteColetivo.planoId || null;
              novoAgendamento.agendamentoConsulta.retorno = pacienteColetivo.retorno || false;
              novoAgendamento.tipoConsultaId = pacienteColetivo.tipoConsultaId || this.agendamento.tipoConsultaId;
              novoAgendamento.agendamentoCompromisso = undefined;
              return this.agendamentoService.Post(novoAgendamento);
            });

            const agendamentosCriados = await Promise.all(promises);

            let mensagemSucesso = '';
            if (foiConvertidoParaColetivo && pacientesParaCriar.length === 1) {
              mensagemSucesso = `Paciente vinculado com sucesso ao agendamento coletivo do horário ${this.agendamento.horaAgendamento}!`;
            } else if (pacientesParaCriar.length === 1) {
              mensagemSucesso = 'Paciente adicionado ao agendamento coletivo com sucesso!';
            } else {
              mensagemSucesso = `Agendamento coletivo criado com sucesso! ${agendamentosCriados.length} agendamento(s) cadastrado(s).`;
            }

            MensagemMixin(3000, 'success', mensagemSucesso);
            this.carregando = false;
            this.fecharModal();
            this.$emit('atualizaCalendario');
            this.$emit('refresh-agendamentos-coletivo');
            return true;
          } catch (error) {
            this.date = '';
            setTimeout(() => {
              this.date = dateBackup;
            }, 1);
            AlertaSimplesErro('Erro ao criar agendamento coletivo:', error);
            this.carregando = false;
            return false;
          }
        }
        // Salva ou edita o agendamento
        let resposta: { data: { tipoAgendamento: TipoAgendamento; agendamentoConsulta: { pacienteId: number }; id: number } };

        if (this.editarAgendamento) {
          resposta = await this.agendamentoService.Put(this.agendamento.id, this.agendamento);
        } else {
          resposta = await this.agendamentoService.Post(this.agendamento);
        }

        if (resposta.data.tipoAgendamento === TipoAgendamento.Consulta) {
          this.idPaciente = resposta.data.agendamentoConsulta.pacienteId;
          this.idAgendamento = resposta.data.id;
        }

        const mensagem = this.editarAgendamento
          ? 'Agendamento editado com sucesso.'
          : 'Agendamento cadastrado com sucesso.';

        MensagemMixin(3000, 'success', mensagem);
        this.fecharModal();
        this.$emit('atualizaCalendario');
        return true;
      } catch (error) {
        // Trata erros
        this.date = '';
        // Ajuste de data (caso seja necessário restaurar)
        // eslint-disable-next-line
        await new Promise((resolve) => setTimeout(resolve, 1));
        this.date = dateBackup;
        AlertaSimplesErro('Aviso:', error);
        this.carregando = false;
        return false;
      }
    },
    async realizarTriagemParaForm() {
      try {
        const pacienteId = this.agendamento.agendamentoConsulta?.pacienteId || this.idPacienteSelecionado;

        if (pacienteId > 0) {
          const pacienteResponse = await this.pacienteService.ObterDadosDoPaciente(pacienteId);
          const paciente = pacienteResponse.data;

          const podeProsseguir = await CadastroCompletoHelper.validarCadastroCompleto(
            pacienteId,
            paciente.cadastroCompleto,
            (id: number) => {
              (this.$refs.modalEditarPaciente as any).abrirModal(id);
            },
          );

          if (!podeProsseguir) {
            return;
          }
        }

        const sucessoAoSalvar = await this.salvar();

        if (sucessoAoSalvar) {
          this.modalTriagens = true;
        }
      } catch (error) {
        AlertaSimplesErro('Erro ao realizar triagem:', error);
      }
    },

    fecharModalTriagem() {
      this.modalTriagens = false;
    },
    onConfirmarCancelamento(motivoCancelamento: string) {
      if (this.pendingCancelamentoResolve) {
        this.pendingCancelamentoResolve(motivoCancelamento);
        this.pendingCancelamentoResolve = null;
      }
    },
    validarDataNascimentoParaDesabilitarTriagem() {
      const { dataNascimento } = this.agendamento.agendamentoConsulta.paciente;

      if (dataNascimento) {
        this.dataNascimentoValido = true;
      } else {
        this.dataNascimentoValido = false;
      }
    },
    desabilitaModulosComplementares() {
      const sessaoUsuario = decode(getToken());
      const temAcessoTriagem = sessaoUsuario.permissions.includes(PermissoesPadrao.AcessoTriagem);
      const temTriagemCreate = sessaoUsuario.permissions.includes(PermissoesPadrao.TriagemCreate);

      if (temAcessoTriagem && temTriagemCreate) {
        return false;
      }

      return true;
    },
    async changePaciente(paciente) {
      this.pacienteSelecionado = paciente[0].usarNomeSocialComoPrincipal
        ? paciente[0].nomeExibirSocial
        : paciente[0].nomeCompleto;
      this.idPacienteSelecionado = paciente[0].id;
      this.agendamento.agendamentoConsulta.pacienteId = this.idPacienteSelecionado;
      this.idPacienteRetorno = this.idPacienteSelecionado;

      await this.$nextTick();
      if (this.$refs.observer) {
        await (this.$refs.observer as any).validate();
      }

      this.obterUltimaConsultaPaciente();
      if (this.tipoPagamentoAtendimento === TipoPagamentoAtendimento.Convenio) {
        this.verificarSePacienteTemConvenioCadastrado();
      }
      try {
        const agendamentos = await this.buscarAgendamentosAbertosFuturos(this.idPacienteSelecionado);
        if (agendamentos.length > 0) {
          this.adicionarAgendamentoEncontradoFila({
            pacienteId: this.idPacienteSelecionado,
            nomePaciente: this.pacienteSelecionado,
            agendamentos,
            origem: 'consulta',
          });
          return;
        }
      } catch (e) {
        AlertaSimplesErro('Erro ao buscar agendamentos do paciente:', e);
      }

      this.atualizarDadosPaciente();
    },

    async changePacientesColetivo(pacientes) {
      if (!pacientes || pacientes.length === 0) {
        if (!this.isEdicaoColetivo) {
          this.pacientesSelecionadosColetivo = [];
        }
        return;
      }

      const novosPacientes = pacientes.map((paciente) => ({
        ...paciente,
        pacienteId: paciente.id,
        cadastroCompleto: paciente.cadastroCompleto,
        telefone: this.obterTelefonePaciente(paciente),
        convenioId: null,
        planoId: null,
        tipoConsultaId: this.agendamento.tipoConsultaId || null,
        situacaoAgendamento: SituacaoAgendamento.Marcado,
        retorno: false,
        agendamentoConfirmado: false,
      }));

      let pacientesAdicionados = novosPacientes;
      const idsExistentes = new Set(
        (this.pacientesSelecionadosColetivo || []).map((p) => `${p.pacienteId || p.id}`),
      );
      const adicionados = novosPacientes.filter((p) => !idsExistentes.has(`${p.pacienteId || p.id}`));
      pacientesAdicionados = adicionados;
      this.pacientesSelecionadosColetivo = [
        ...(this.pacientesSelecionadosColetivo || []),
        ...adicionados,
      ];

      const promises = novosPacientes.map(async (paciente) => {
        try {
          const res = await this.pacienteService.BuscarPacientePorIdComConvenios(paciente.id);
          if (res.data) {
            paciente.telefone = this.obterTelefonePaciente(res.data) || paciente.telefone || '';
            if (res.data.convenios && res.data.convenios.length > 0) {
              paciente.conveniosDisponiveis = res.data.convenios.map((c) => ({
                value: c.convenioId,
                text: c.nome,
                periodoRetornoDias: c.periodoRetornoDias ?? 0,
              }));
            }
          }
        } catch (error) {
          console.error(`Erro ao buscar convênios do paciente ${paciente.id}:`, error);
        }
        return paciente;
      });

      await Promise.all(promises);

      if (pacientesAdicionados && pacientesAdicionados.length > 0) {
        const verificacoes = pacientesAdicionados.map(async (paciente) => {
          try {
            const agendamentos = await this.buscarAgendamentosAbertosFuturos(paciente.pacienteId || paciente.id);
            if (agendamentos.length > 0) {
              this.adicionarAgendamentoEncontradoFila({
                pacienteId: paciente.pacienteId || paciente.id,
                nomePaciente: paciente.nomeCompleto || paciente.nomeExibirSocial || '',
                agendamentos,
                origem: 'coletivo',
              });
            }
          } catch (error) {
            console.warn('Erro ao buscar agendamentos do paciente:', error);
          }
        });
        await Promise.all(verificacoes);
      }
    },
    removerPacienteColetivo(pacienteColetivo) {
      const pacienteId = pacienteColetivo?.pacienteId || pacienteColetivo?.id;
      if (!pacienteId) {
        return;
      }

      this.pacientesSelecionadosColetivo = (this.pacientesSelecionadosColetivo || [])
        .filter((p) => (p.pacienteId || p.id) !== pacienteId);
      MensagemMixin(2000, 'success', 'Paciente removido do agendamento coletivo.');
    },
    podeExcluirPacienteColetivo(pacienteColetivo) {
      if (!this.editarAgendamento) {
        return true;
      }
      const situacao = pacienteColetivo?.situacaoAgendamento;
      return situacao === SituacaoAgendamento.Cancelado || situacao === 5;
    },
    abrirModalObservacoes(paciente, index) {
      this.pacienteObservacaoAtual = { ...paciente };
      this.indexPacienteObservacao = index;
      this.modalObservacoes = true;
    },
    fecharModalObservacoes() {
      this.modalObservacoes = false;
      this.pacienteObservacaoAtual = {};
      this.indexPacienteObservacao = -1;
    },
    salvarObservacoes() {
      if (this.indexPacienteObservacao >= 0) {
        this.pacientesSelecionadosColetivo[this.indexPacienteObservacao].observacao = this.pacienteObservacaoAtual.observacao;
        this.pacientesSelecionadosColetivo[this.indexPacienteObservacao].orientacoesPaciente = this.pacienteObservacaoAtual.orientacoesPaciente;
      }
      MensagemMixin(2000, 'success', 'Observações salvas com sucesso!');
      this.fecharModalObservacoes();
    },
    getConvenioFullName(paciente: any): string {
      try {
        const convenios = paciente && paciente.conveniosDisponiveis ? paciente.conveniosDisponiveis : [];
        const selected = paciente ? paciente.convenioId : null;
        if (!convenios || convenios.length === 0) {
          return 'Não registrado';
        }
        const found = convenios.find((c: any) => c.value === selected);
        if (found && found.text) return found.text;
        const fallback = convenios.find((c: any) => c.id === selected || String(c.value) === String(selected));
        return (fallback && (fallback.text || fallback.nome)) || (convenios[0].text || 'Não registrado');
      } catch (e) {
        return '';
      }
    },
    async mudarPlanosColetivo(paciente) {
      if (paciente.convenioId) {
        try {
          const res = await this.planoService.BuscarPlanosPorConvenioId(paciente.convenioId);
          paciente.planosDisponiveis = res.data.map((p) => ({
            value: p.id,
            text: p.nome,
          }));
        } catch (error) {
          console.error('Erro ao buscar planos:', error);
        }
      } else {
        paciente.planosDisponiveis = [];
        paciente.planoId = null;
      }
    },
    async obterTodosOsHorariosReservadosDesdeHoje(): Promise<IHorarioReservado[]> {
      this.carregando = true;
      try {
        const todosHorariosReservados = await this.agendaService.ObterTodosOsHorariosReservadosDesdeHoje();

        if (todosHorariosReservados && todosHorariosReservados.data) {
          return Array.isArray(todosHorariosReservados.data) ? todosHorariosReservados.data : [];
        }

        return [];
      } catch (error) {
        AlertaSimplesErro('Erro ao buscar bloqueios e feriados:', error);
        return [];
      } finally {
        this.carregando = false;
      }
    },
    async verificarSeExisteConflitoDeAgenda(data: string, horario: string): Promise<any[]> {
      const horariosReservados = await this.obterTodosOsHorariosReservadosDesdeHoje();

      if (!Array.isArray(horariosReservados) || horariosReservados.length === 0) {
        // Nenhum horário reservado encontrado.
        return [];
      }

      const dataHorarioVerificada = new Date(`${data}T${horario}`);
      const itensConflitantes = horariosReservados.filter((item) => {
        const inicio = new Date(item.dataInicio);
        const fim = new Date(item.dataFim);
        const estaNoIntervalo = dataHorarioVerificada >= inicio && dataHorarioVerificada <= fim;

        if (!estaNoIntervalo) {
          return false;
        }

        if (item.tipo === 'AGENDAMENTO' && item.situacaoAgendamento === 5) {
          return false;
        }

        return true;
      });

      return itensConflitantes;
    },
    async carregarDadosDoPacienteSelecionado() {
      const pacienteCarregadoNaSessaoAtual = this.verificarSeExistemDadosNaSessaoArmazenamento();

      if (!pacienteCarregadoNaSessaoAtual && this.idPacienteSelecionado === 0) {
        return;
      }

      if (!pacienteCarregadoNaSessaoAtual) {
        if (this.idPacienteSelecionado > 0) {
          this.carregando = true;
          const paciente = await this.pacienteService.ObterDadosDoPaciente(this.idPacienteSelecionado);

          if (paciente.data) {
            this.$nextTick(() => {
              this.persistirDadosPacienteSessaoArmazenamento(paciente.data);
              this.recarregarDadosPaciente(paciente.data);
              this.carregando = false;
            });
            return;
          }
        }

        this.carregando = false;
        return;
      }

      this.carregando = true;
      this.$nextTick(() => {
        const paciente = this.obterDadosPacienteSessaoArmazenamento();
        this.recarregarDadosPaciente(paciente);
        this.carregando = false;
      });
    },
    recarregarDadosPaciente(paciente: Pacientes) {
      this.agendamento.agendamentoConsulta = {
        ...this.agendamento.agendamentoConsulta,
        paciente,
        email: paciente.contato.emailPrincipal,
        telefone: paciente.contato.telefonePrincipal,
        pacienteId: paciente.id,
      };
      this.cpfPaciente = paciente.cpf;
      this.pacienteSelecionado = paciente.nomeCompleto;
    },
    persistirDadosPacienteSessaoArmazenamento(dadosPaciente: Pacientes) {
      sessionStorage.setItem(this.SESSAO_PACIENTE_ARMAZENAMENTO, JSON.stringify(dadosPaciente));
    },
    obterDadosPacienteSessaoArmazenamento() {
      return JSON.parse(sessionStorage.getItem(this.SESSAO_PACIENTE_ARMAZENAMENTO) || '{}');
    },
    verificarSeExistemDadosNaSessaoArmazenamento() {
      return Object.keys(this.obterDadosPacienteSessaoArmazenamento()).length > 0;
    },
    limparDadosPacienteSessaoArmazenamento() {
      sessionStorage.removeItem(this.SESSAO_PACIENTE_ARMAZENAMENTO);
    },
    async carregarTipoConsultas() {
      const tenant = await this.tenantService.GetTenantDoUsuario();

      if (tenant && tenant.data) {
        this.tenant = tenant.data;

        const listaTiposConsultaResponse = await this.tipoConsultaService.obterParaConsulta(tenant.data?.clinicaId);

        if (listaTiposConsultaResponse && listaTiposConsultaResponse.data) {
          this.options_consulta = listaTiposConsultaResponse.data.map((item: { id: number; descricao: string }) => ({ value: item.id, text: item.descricao }));
        }
      }
    },
    async clickSituacaoAgendamento(situacaoAgendamento: SituacaoAgendamento) {
      const situacaoAtual = this.agendamento.situacaoAgendamento;

      if (situacaoAgendamento === SituacaoAgendamento.EmEspera && this.agendamento.tipoAgendamento === TipoAgendamento.Consulta) {
        const pacienteId = this.agendamento.agendamentoConsulta?.pacienteId || this.idPacienteSelecionado;

        if (pacienteId > 0) {
          try {
            const pacienteResponse = await this.pacienteService.ObterDadosDoPaciente(pacienteId);
            const paciente = pacienteResponse.data;

            const podeProsseguir = await CadastroCompletoHelper.validarCadastroCompleto(
              pacienteId,
              paciente.cadastroCompleto,
              (id: number) => {
                (this.$refs.modalEditarPaciente as any).abrirModal(id);
              },
            );

            if (!podeProsseguir) {
              this.agendamento.situacaoAgendamento = situacaoAtual;
              return;
            }
          } catch (error) {
            AlertaSimplesErro('Erro ao validar cadastro:', error);
            this.agendamento.situacaoAgendamento = situacaoAtual;
            return;
          }
        }
      }

      this.agendamento.situacaoAgendamento = situacaoAgendamento;
    },
    async clickSituacaoAgendamentoColetivo(pacienteColetivo: any, situacaoAgendamento: SituacaoAgendamento) {
      const situacaoAtual = pacienteColetivo?.situacaoAgendamento;

      if (situacaoAgendamento === SituacaoAgendamento.EmEspera) {
        const pacienteId = pacienteColetivo?.pacienteId || pacienteColetivo?.id || 0;
        if (pacienteId > 0) {
          try {
            let cadastroCompleto = pacienteColetivo?.cadastroCompleto;
            if (cadastroCompleto === undefined || cadastroCompleto === null) {
              const pacienteResponse = await this.pacienteService.ObterDadosDoPaciente(pacienteId);
              cadastroCompleto = pacienteResponse?.data?.cadastroCompleto;
            }

            const podeProsseguir = await CadastroCompletoHelper.validarCadastroCompleto(
              pacienteId,
              cadastroCompleto,
              (id: number) => {
                (this.$refs.modalEditarPaciente as any).abrirModal(id);
              },
            );

            if (!podeProsseguir) {
              pacienteColetivo.situacaoAgendamento = situacaoAtual;
              return;
            }
          } catch (error) {
            AlertaSimplesErro('Erro ao validar cadastro:', error);
            pacienteColetivo.situacaoAgendamento = situacaoAtual;
            return;
          }
        }
      }

      pacienteColetivo.situacaoAgendamento = situacaoAgendamento;
    },
    fecharDialog() {
      this.confirmaCancelamentoAgendamento = false;
      if (this.pendingCancelamentoResolve) {
        this.pendingCancelamentoResolve = null;
      }
    },
    onConfirmarAgendamentosPaciente() {
      this.modalAgendamentosPaciente = false;
      this.aguardandoConfirmacaoAgendamentos = false;
      const origem = this.pacienteAgendamentoEncontradoAtual?.origem;
      this.pacienteAgendamentoEncontradoAtual = null;
      if (origem === 'consulta') {
        this.atualizarDadosPaciente();
      }
      this.processarFilaAgendamentosEncontrados();
    },
    executarValidacaoInicial() {
      if (!this.validacaoInicialExecutada && this.$refs.observer) {
        this.validacaoInicialExecutada = true;
        (this.$refs.observer as any).validate();
      }
    },
    onCancelarAgendamentosPaciente() {
      this.modalAgendamentosPaciente = false;
      this.aguardandoConfirmacaoAgendamentos = false;
      const origem = this.pacienteAgendamentoEncontradoAtual?.origem;
      const pacienteIdAtual = this.pacienteAgendamentoEncontradoAtual?.pacienteId;
      this.pacienteAgendamentoEncontradoAtual = null;
      if (origem === 'consulta') {
        this.pacienteSelecionado = '';
        this.idPacienteSelecionado = 0;
        this.agendamento.agendamentoConsulta.pacienteId = 0;
      }
      if (origem === 'coletivo' && pacienteIdAtual) {
        this.pacientesSelecionadosColetivo = (this.pacientesSelecionadosColetivo || [])
          .filter((p) => `${p.pacienteId || p.id}` !== `${pacienteIdAtual}`);
      }
      this.processarFilaAgendamentosEncontrados();
    },
    async buscarAgendamentosAbertosFuturos(pacienteId: number) {
      const res = await this.agendamentoService.BuscarConsultasPorPaciente(pacienteId);
      if (!res.data || res.data.length === 0) {
        return [];
      }

      const hoje = new Date();
      const hojeInicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
      return res.data
        .filter((ag) => {
          if (!ag.dataAgendamento || typeof ag.dataAgendamento !== 'string') {
            console.warn('Agendamento inválido (sem dataAgendamento):', ag);
            return false;
          }
          try {
            const dataAgendamento = new Date(ag.dataAgendamento);
            if (Number.isNaN(dataAgendamento.getTime())) {
              console.warn('DataAgendamento inválida:', ag.dataAgendamento, ag);
              return false;
            }
            return dataAgendamento >= hojeInicio;
          } catch (e) {
            console.warn('Erro ao processar dataAgendamento:', ag.dataAgendamento, e);
            return false;
          }
        })
        .sort((a, b) => new Date(a.dataAgendamento).getTime() - new Date(b.dataAgendamento).getTime());
    },
    obterTelefonePaciente(paciente: any) {
      return paciente?.contatos?.telefonePrincipal
        || paciente?.contato?.telefonePrincipal
        || paciente?.telefonePrincipal
        || paciente?.telefone
        || '';
    },
    adicionarAgendamentoEncontradoFila(item: {
      pacienteId: number;
      nomePaciente: string;
      agendamentos: any[];
      origem: 'consulta' | 'coletivo';
    }) {
      this.filaPacientesAgendamentosEncontrados.push(item);
      this.processarFilaAgendamentosEncontrados();
    },
    async processarFilaAgendamentosEncontrados() {
      if (this.aguardandoConfirmacaoAgendamentos) {
        return;
      }
      const proximo = this.filaPacientesAgendamentosEncontrados.shift();
      if (!proximo) {
        return;
      }

      this.aguardandoConfirmacaoAgendamentos = true;
      this.pacienteAgendamentoEncontradoAtual = proximo;
      this.agendamentosPaciente = proximo.agendamentos;
      this.nomePacienteModalAgendamentos = proximo.nomePaciente;
      this.pacienteIdModalAgendamentos = proximo.pacienteId;

      await this.$nextTick();
      this.modalAgendamentosPaciente = true;
    },
    onInputTipoPagamentoAtendimento(valor: number) {
      if (valor === TipoPagamentoAtendimento.Convenio) {
        const temConvenio = this.verificarSePacienteTemConvenioCadastrado(valor);
        if (!temConvenio) {
          return;
        }
      }
      this.tipoPagamentoAtendimento = valor;
      if (this.tipoPagamentoAtendimento === TipoPagamentoAtendimento.Particular) {
        this.agendamento.agendamentoConsulta.convenioId = null;
        this.agendamento.agendamentoConsulta.planoId = null;
        this.options_plano = [];
      }
    },
    verificarSePacienteTemConvenioCadastrado() {
      if (!this.idPacienteSelecionado && this.pacienteSelecionado === '' && !this.preAgendamento) {
        MensagemMixin(3000, 'warning', 'Nenhum paciente selecionado. Selecione um paciente para escolher convênio.');
        this.$nextTick(() => {
          this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
          return false;
        });
      }
      if (this.preAgendamento && (this.options_convenio.length === 0 || this.options_convenio[0].value === null || this.options_convenio[0].text === '')) {
        MensagemMixin(3000, 'warning', 'Não existem convênios ativos nessa clínica.');
        this.$nextTick(() => {
          this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
          return false;
        });
      } else if (this.options_convenio.length === 0 || this.options_convenio[0].value === null || this.options_convenio[0].text === '') {
        MensagemMixin(3000, 'warning', 'Paciente não possui convênio cadastrado.');
        this.$nextTick(() => {
          this.tipoPagamentoAtendimento = TipoPagamentoAtendimento.Particular;
          return false;
        });
      }
      return true;
    },
  },
});
</script>

<style>
.criar-agendamento-dialog-content {
  z-index: 3005 !important;
}

.criar-agendamento-dialog-content .v-dialog {
  border-radius: 20px !important;
  overflow: hidden !important;
}

@media (max-width: 768px) {
  .criar-agendamento-dialog-content .v-dialog {
    border-radius: 16px !important;
    overflow: hidden !important;
    margin: 16px !important;
  }
}
</style>

<style scoped>

/* MODAL PRINCIPAL */
.criar-agendamento-modal {
  border-radius: 20px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.4) !important;
  background: white !important;
}


.modern-tab {
  color: var(--especialidade-primary) !important;
}

/* HEADER LIMPO E MINIMALISTA */
.modal-header {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  padding: 24px 32px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
  background-clip: padding-box;
}

.header-content {
  display: flex !important;
  align-items: center !important;
  gap: 16px !important;
}

.header-text {
  color: white !important;
}

.header-title {
  font-size: 24px !important;
  font-weight: 700 !important;
  margin: 0 !important;
  color: white !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
}

.header-subtitle {
  font-size: 14px !important;
  margin: 4px 0 0 0 !important;
  color: rgba(255, 255, 255, 0.9) !important;
  font-weight: 400 !important;
}

.close-btn {
  transition: all 0.3s ease !important;
}

.close-btn:hover {
  opacity: 0.8 !important;
}

/* CARD UNIFICADO */
.unified-content {
  padding: 24 24px !important;
}

.unified-card {
  background: white !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #e9ecef !important;
  overflow: hidden !important;
}

/* CONTEÚDO DO FORMULÁRIO */
.form-content {
  padding: 48px !important;
  background: white !important;
}

/* TOGGLE BUTTONS MODERNOS */
.v-btn-toggle {
  background: #f8f9fa !important;
  border-radius: 12px !important;
  padding: 4px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e9ecef !important;
}

.v-btn-toggle .v-btn {
  border-radius: 8px !important;
  margin: 0 2px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  transition: all 0.3s ease !important;
}

.v-btn-toggle .v-btn--active {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3) !important;
  transform: translateY(-1px) !important;
}

.v-btn-toggle .v-btn:not(.v-btn--active) {
  color: #6c757d !important;
  background: transparent !important;
}

.v-btn-toggle .v-btn:not(.v-btn--active):hover {
  background: rgba(46, 75, 157, 0.1) !important;
  color: var(--especialidade-primary, #2e4b9d) !important;
}

/* CAMPOS DO FORMULÁRIO */
.v-text-field,
.v-select,
.v-textarea {
  background: white !important;
  border-radius: 8px !important;
}

.v-icon {
  margin: 0 !important;
}

.v-text-field .v-input__control .v-input__slot,
.v-select .v-input__control .v-input__slot,
.v-textarea .v-input__control .v-input__slot {
  border-radius: 8px !important;
  border: 1px solid #e9ecef !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.v-text-field .v-input__control .v-input__slot:focus-within,
.v-select .v-input__control .v-input__slot:focus-within,
.v-textarea .v-input__control .v-input__slot:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

/* SWITCHES MODERNOS */
.soi-switch {
  background: #f8f9fa !important;
  border-radius: 20px !important;
  padding: 8px 16px !important;
  border: 1px solid #e9ecef !important;
}

/* AÇÕES DO FORMULÁRIO */
.form-actions {
  padding: 24px 32px !important;
  background: #f8f9fa !important;
  border-top: 1px solid #e9ecef !important;
  margin-top: 0 !important;
}

.actions-container {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
}

.action-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  padding: 12px 24px !important;
  min-width: 120px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
}

.action-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
}

.triagem-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
}

.triagem-btn:hover {
  background: var(--especialidade-secondary, #1e3a8a) !important;
}

.cancel-btn {
  background: #6c757d !important;
  color: white !important;
}

.cancel-btn:hover {
  background: #5a6268 !important;
}

.save-btn {
  background: #28a745 !important;
  color: white !important;
}

.save-btn:hover {
  background: #218838 !important;
}

@media (max-width: 768px) {
  .criar-agendamento-modal {
    max-width: calc(100vw - 32px) !important;
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  .modal-header {
    padding: 20px 24px !important;
    background: var(--especialidade-gradient, #2e4b9d) !important;
    border-top-left-radius: 16px !important;
    border-top-right-radius: 16px !important;
  }

  .header-title {
    font-size: 20px !important;
  }

  .header-subtitle {
    font-size: 13px !important;
  }

  .unified-content {
    padding: 0 24px !important;
  }

  .form-content {
    padding: 24px !important;
  }

  .form-actions {
    padding: 20px 24px !important;
  }

  .actions-container {
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .action-btn {
    width: 100% !important;
    margin-bottom: 8px !important;
  }
}

@media (max-width: 480px) {
  .header-content {
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 12px !important;
  }

  .header-icon {
    align-self: flex-start !important;
  }

  .form-actions {
    padding: 14px 12px !important;
  }

  .action-btn {
    min-height: 38px !important;
    padding: 10px 12px !important;
    font-size: 0.74rem !important;
    letter-spacing: 0.02em !important;
  }
}

@media (max-width: 380px) {
  .form-actions {
    padding: 12px 10px !important;
  }

  .action-btn {
    min-height: 36px !important;
    padding: 8px 10px !important;
    font-size: 0.7rem !important;
    letter-spacing: 0.01em !important;
  }
}

/* ANIMAÇÕES */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.criar-agendamento-modal {
  animation: fadeInUp 0.4s ease-out !important;
}

.unified-card {
  animation: fadeInUp 0.5s ease-out 0.1s both !important;
}

.form-actions {
  animation: fadeInUp 0.6s ease-out 0.2s both !important;
}
</style>
